import { HttpErrorResponse } from '@angular/common/http';
import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ThirdPartyService } from '../../third-party.service';
import { ConfigService } from 'src/app/services/config.service';
import { ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';
import { PrivilegesService } from 'src/app/services/privileges.service';
import { debounceTime, distinctUntilChanged, switchMap, takeUntil, tap } from 'rxjs/operators';
import { FeatureFlagService } from 'src/app/services/feature-flag.service';
import { merge, Subject, Subscription } from 'rxjs';
import * as moment from 'moment';
import { LayoutService, NavbarBtn } from 'src/app/layout/layout.service';
import * as e from 'express';

export enum OrderStatus {
  Saved = 'Saved',
  Paid = 'Paid',
  Partial = 'Partial',
  UnsavedChanges = 'Not saved'
}

@Component({
  selector: 'app-service-details',
  templateUrl: './service-details.component.html',
  styleUrls: ['./service-details.component.scss'],
  providers: [DatePipe]
})
export class ServiceDetailsComponent implements OnInit, OnDestroy {
  @ViewChild('menuContainer') menuContainerRef!: ElementRef;
  @ViewChild('finalAmountInput') finalAmountInput!: ElementRef<HTMLInputElement>;
  @ViewChild('patternLock', { read: ElementRef }) patternLock!: ElementRef;
  billForm!: FormGroup;
  serviceNearDetailForm!: FormGroup;
  editingProductForm: FormGroup;
  RefundForm!: FormGroup;

  isLoading: boolean = true;
  isEditMode: boolean = false;
  isSearching: boolean = false;
  isServiceCollapsed: boolean = false;
  isSaleSuccess: boolean = false;
  showUpdateButton: boolean = false;
  isPartsSectionOpen: boolean = false;
  showAssignedPerson: boolean = false;
  isPartsSearchFocused: boolean = false;
  isServiceSectionOpen: boolean = false;
  isPaymentSectionOpen: boolean = false;
  isStatusInaccessible: boolean = false;
  renderAssignPersonDiv: boolean = false;
  isServiceDropdownOpen: boolean = false;
  isPartsDropdownOpen: boolean = false;
  amountWithoutCashExceedsDue: boolean = false;
  isServiceOpen: boolean = false;
  isPartsOpen: boolean = true;
  isPaymentOpen: boolean = false;
  showPayInModal: boolean = false;
  showProductEditModal: boolean = false;
  showRefundModal: boolean = false;
  showPaymentModesModal: boolean = false;
  advanceRecievedJob: boolean = false;
  showEditAdvanceModal: boolean = false;
  doJobHaveCredit: boolean = false;
  isCostAndPayDisabled: boolean = false;
  isApiCalling: boolean = false;
  isPayAndConfirmDisabled: boolean = false;
  isCostAndPaymentEnabledSeller: boolean = false
  doHaveQuickProducts: boolean = false;
  showRefundWithoutReturnModal: boolean = false;
  isOrderPaymentModels: boolean = false;
  showServiceWarningModal: boolean = false;
  showMRPEditWarningModal: boolean = false;
  finalPriceIsMaster:boolean = false;

  workId: any;
  defaultID: any;
  salesDetails: any;
  successfulBillNumber: any;
  successfulOrderNumber: any;
  editAdvancedPaymentInfo: any;

  page: number = 2;
  serviceProductsLength: number = 0;
  inventoryProductsLength: number = 0;
  editingProductIndex: number = -1;
  SalesPOSOrderID: number = 0;
  currentCreditBalance: number = 0;
  prevAdvanceAmount: number = 0;
  paidAmountOnJob: number = 0;
  menuHeight = 0;
  prevFinalAmount: number = 0;
  previousInventoryTotal = 0;
  defaultProductOrderDetailID: number = 0;
  isFinalAmountEdited: boolean = false;
  prevMRP: number = 0;

  userList: any[] = [];
  modelNames: any[] = [];
  phoneNames: any[] = [];
  jobDetails: any[] = [];
  statusList: any[] = [];
  statusAccess: any = [];
  deviceTypes: any[] = [];
  userPrivileges: any = [];
  serviceProducts: any[] = [];
  inventoryProducts: any[] = [];
  filteredStatusList: any[] = [];
  allSelectedProducts: any[] = [];
  filteredServicesList: any[] = [];
  filteredInventoryList: any[] = [];
  originalServiceProducts: any[] = [];
  originalInventoryProducts: any[] = [];

  showQuickAddProductForm = false;
  quickAddProductType: 'service' | 'inventory' = 'service';
  showMoreFields = false;
  quickAddProductForm!: FormGroup;
  subscription = new Subscription;

  public orderTransactions = {
    transactionsList: [] as any[],
    selectedColumns: [] as any[],
    cols: [] as any[],
    displayOrderTransactionList: false,
    isTransactionLoading: false
  };

  flag: any;
  userID: any = 0;
  branchID: any = 0;
  currentWorkStatus: any = '';
  selectedWorkStatus: any = '';
  currentAssignedUser: any = ''
  formttedDeliveryDate: any = '';
  calledFrom: 'checkout' | 'refund' | 'update' | 'edit-advance' | 'add-advance' = 'checkout';
  workStatusFormInitialValue: any = null;
  prevPaymentInfo: any;
  defaultProduct: any;

  toolbarData: any = {};
  originalWorkStatusValues: any = {};
  customerDetails: any = {};

  editingProductType: 'service' | 'inventory' = 'service';
  continueTo: 'checkout' | 'update' = 'checkout';

  paramsService = {
    takeAll: false,
    skip: 0,
    take: 100,
    categoryID: 0,
    keyword: '',
    productsFor: 'admin',
    productsType: 'service',
    organisationID: 0,
    ShowInactiveProductsOnly: false,
    ShowUnpublishedProductsOnly: false,
    ShowOutOfStockProductsOnly: false
  };

  paramsInventory = {
    takeAll: false,
    skip: 0,
    take: 100,
    categoryID: 0,
    keyword: '',
    productsFor: 'admin',
    productsType: 'inventory',
    organisationID: 0,
    ShowInactiveProductsOnly: false,
    ShowUnpublishedProductsOnly: false,
    ShowOutOfStockProductsOnly: false
  };

  paramsServiceInfo = {
    UserID: 0,
    workId: ''
  }

  statusParams = {
    key: '',
    takeAll: true,
    skip: 0,
    take: 0,
    isDateChecked: false,
    fromDate: '',
    toDate: '',
    branchID: '',
    userType: ''
  }

  updationParams = {
    id: '',
    createdBy: 0,
    customerDescription: '',
    minServiceCost: 0,
    maxServiceCost: 0,
    workDescription: '',
    workStatus: '',
    updatedOn: new Date,
    branchID: '',
    serviceCost: 0,
    finalCost: 0,
    collectedPerson: '',
    collectedPersonNo: '',
    transferBranch: 0,
    transferType: '',
    branchType: 'Mobile',
    partsCost: '',
    warrantyData: '',
    approvedAmount: 0,
    cost: '',
    payment: 0,
    discount: 0,
    balance: 0,
    changeOnly: '',
    issms: true
  }

  userParams = {
    key: "",
    takeAll: true,
    skip: 0,
    take: 0,
    isDateChecked: true,
    fromDate: "2025-07-20T08:12:52.876Z",
    toDate: "2025-07-20T08:12:52.876Z",
    branchID: "",
    userType: ""
  }

  transactionGetParams: any = {
    key: "",
    takeAll: true,
    skip: 0,
    take: 0,
    isDateChecked: false,
    fromDate: 0,
    toDate: 0,
    shopId: 0,
    orderID: 0
  };

  banks = [
    { name: 'Canara', value: 'canara' },
    { name: 'HDFC', value: 'hdfc' },
    { name: 'SBI', value: 'sbi' }
  ]

  // for tost msg
  notificationMsg = '';
  showToast: boolean = false;
  isSuccess: boolean;

  private selectedReturnTotals = {
    quantity: 0,
    amount: 0
  };

  //Counter Logic
  counter: number = 0;
  counterInterval: any;
  isCountingDown: boolean = false;
  showFinalAmtSaveBtn; boolean = false;

  currentOrderStatus: OrderStatus | null = null;
  isInitialPatchComplete: boolean = false;

  accessoriesConfig = {
    accessoriesProvided: [],
    accessoriesMissing: []
  };

  providedArray: any[] = [];
  missingArray: any[] = [];

  patternInterval: any;
  pass: number = 2;

  constructor(
    public thirdPartyService: ThirdPartyService,
    private fb: FormBuilder,
    private configService: ConfigService,
    private route: ActivatedRoute,
    private datePipe: DatePipe,
    public privilegeService: PrivilegesService,
    private featureFlagService: FeatureFlagService,
    private layoutService: LayoutService,
  ) {
  }

  ngOnInit() {
    this.isCostAndPaymentEnabledSeller = this.featureFlagService.getFeatureStatus('service_job_with_accounts', false);
    this.GetThirdPartySettings();
    this.privilegeService.getUserPrivileges();
    this.getUserAndBranchID();
    this.loadFromStorage();
    this.getFormValueSuggesstions();
    this.setAllForms();
    this.populateToolbarData();

    this.subscription.add(this.route.queryParams.subscribe(params => {
      this.workId = params['workID'];
      this.paramsServiceInfo.workId = this.workId;
      this.updationParams.id = this.workId;
    }));

    this.filteredStatusList = this.statusAccess.map(status => ({
      Status: status.status,
      disabled: false
    }));

    // Subscribe to WorkStatus field changes
    this.subscription.add(this.serviceNearDetailForm.get('workStatusFormGroup.WorkStatus')?.valueChanges.subscribe(
      (value) => {
        const statusControl = this.serviceNearDetailForm.get('workStatusFormGroup.AssignedUser')
        if (value == 'In Progress') {
          statusControl?.setValidators([Validators.required]);
        } else {
          statusControl?.clearValidators();
        }
        statusControl?.updateValueAndValidity();
      }
    ));

  }

  ngAfterViewInit() {
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  public getUserAndBranchID() {
    this.subscription.add(this.thirdPartyService.getStaffIdAndBrandchId().subscribe((res: any) => {
      if (res && res?.Result == "Success" && res?.ResponseData) {
        let response = res?.ResponseData
        this.branchID = response.BranchId
        this.userID = response.UserId;

        this.statusParams.branchID = this.branchID;
        this.updationParams.branchID = String(this.branchID);
        this.userParams.branchID = this.branchID;

        this.paramsServiceInfo.UserID = this.userID;
        this.updationParams.createdBy = this.userID;

        this.getUserPriveleges();
        this.getServices();
        this.getUsers();
        this.getInventoryProducts();
        this.getServiceInfo();
      }
    }, (error: HttpErrorResponse) => {
      this.isLoading = false;
    }));
  }

  private getUserPriveleges() {
    const privileges = localStorage.getItem('sevicenearStatus');
    if (privileges) {
      this.userPrivileges = JSON.parse(privileges);
      const statusList = this.userPrivileges;
      this.statusList = statusList;
      this.statusAccess = statusList.filter(item => item.allowed === true);

    }
  }

  public getUsers() {
    this.subscription.add(this.thirdPartyService.getBranchUsers(this.userParams).subscribe((res: any) => {
      if (res && res?.Result == "Success" && res?.ResponseData) {
        this.userList = res?.ResponseData
      }
    },
      (error: HttpErrorResponse) => {
        this.isLoading = false;
      }));
  }

  public getServiceInfo() {
    this.isLoading = true;
    this.subscription.add(this.thirdPartyService.getWorkOrderByID(this.paramsServiceInfo).subscribe((res: any) => {
      if (res && res?.Result == "Success" && res?.ResponseData) {
        this.jobDetails = res.ResponseData;
        if (this.jobDetails[0].ShopName) {
          this.customerDetails = {
            FirstName: this.jobDetails[0].ShopName,
            ID: this.jobDetails[0].SalesPOSUserID,
          }

          this.layoutService.setToolbar({
            title: 'Details',
            isShopService: true,
            shopName: this.jobDetails[0].ShopName,
          });

        } else {
          this.customerDetails = {
            FirstName: this.jobDetails[0].ContactPerson,
            ID: 0,
          }

          this.layoutService.setToolbar({
            title: 'Details',
            isCustomerService: true,
            customerName: this.jobDetails[0].ContactPerson,
          });
        }

        if (this.jobDetails.length > 0) {

          const latest = this.jobDetails[0];
          if (latest.SalesPosOrderId) {
            this.SalesPOSOrderID = latest.SalesPosOrderId;

            this.getOrderDetails(latest.SalesPosOrderId);
          }
          const workStatusOfJob = latest.WorkStatus;
          const compareStatus = this.statusList.find((item: any) => {
            return item.status === workStatusOfJob;
          })
          if (!compareStatus) {
            this.isStatusInaccessible = true;
          }
          const formateddate = this.datePipe.transform(latest.DeliveryDate, 'dd MMM yyyy hh:mma');;
          this.formttedDeliveryDate = formateddate;

          this.serviceNearDetailForm.get('jobDetailFormGroup')?.patchValue(latest);

          const newAssignedUser = this.userList.find((item: any) => {
            return item.UserID == latest.AssignedUserID;
          });

          if (newAssignedUser) {
            this.currentAssignedUser = newAssignedUser.Name;
          }
          // this.serviceNearDetailForm.get('workStatusFormGroup')?.patchValue({
          //   WorkStatus: latest.WorkStatus,
          //   AssignedUser: latest.AssignedUser,
          //   currentStatusOfDevice: latest.ServiceDescription,
          //   messageCustomer: latest.CustomerDescription,
          // });
          this.currentWorkStatus = latest.WorkStatus;
          this.handleWorkStatusChange(latest.WorkStatus);
          this.setFilteredStatusList();
          this.serviceNearDetailForm.get('workStatusFormGroup')?.patchValue({
            WorkStatus: latest.WorkStatus,
            AssignedUser: latest.AssignedUser,
            currentStatusOfDevice: '',
            messageCustomer: latest.CustomerDescription,
          });

          this.workStatusFormInitialValue = this.getWorkStatusFormValue();

          // Store the original patched values for enabling change btn only if value changes
          this.originalWorkStatusValues = this.serviceNearDetailForm.get('workStatusFormGroup')?.getRawValue();

          if (this.jobDetails[0]?.Accessories) {
            const accessoritesProvided = JSON.parse(this.jobDetails[0]?.Accessories);
            this.createAndPatchAccessoriesForm(accessoritesProvided);
          }
          if(this.jobDetails[0]?.Pattern){
            const devicePass = JSON.parse(this.jobDetails[0]?.Pattern);

            if(devicePass.pat){
              this.startPatternAnimation(devicePass.pat);
              this.serviceNearDetailForm.get('jobDetailFormGroup')?.get('Pattern')?.setValue('');
              this.changePatternOrPassword(1);
            }else{
              if(devicePass.pas){
                this.serviceNearDetailForm.get('jobDetailFormGroup')?.get('Pattern')?.setValue(devicePass.pas);
              }else{
                this.serviceNearDetailForm.get('jobDetailFormGroup')?.get('Pattern')?.setValue(this.jobDetails[0]?.Pattern);
              }
            }
          }
        }
        this.isLoading = false;
      }
    }, (error: HttpErrorResponse) => {
      this.isLoading = false;
    }));
  }

  private setAllForms() {
    this.serviceNearDetailForm = this.fb.group({
      jobDetailFormGroup: this.fb.group({
        WorkCode: '',
        InternalWorkCode: '',
        DeviceType: [''],
        Manufacture: [''],
        ModelName: ['', Validators.required],
        DeliveryDate: ['', Validators.required],
        Pattern: '',
        IMEI: [''],
        WorkDescription: ['', Validators.required],
        CustomerDescription: '',
        PatternLock: [''],
        AssignedUser: [null],
        ContactPerson: '',
        ContactNo: '',
        ShopName: '',
        EmailID: '',
        ContactAddress: '',
        MinServiceCost: [''],
        MaxServiceCost: [''],
        AdvanceServiceCost: [''],
      }),
      workStatusFormGroup: this.fb.group({
        WorkStatus: [''],
        currentStatusOfDevice: [''],
        messageCustomer: [''],
        AssignedUser: [null, [Validators.required]]
      }),
      statusOnly: [false],
    });
    this.billForm = this.fb.group({
      serviceSearch: [''],
      partsSearch: [''],
      customDiscount: [''],
      serviceDiscount: [''],
      partsDiscount: [''],
      serviceProducts: this.fb.array([]),
      inventoryProducts: this.fb.array([]),
      newAdvance: [0],
      finalAmt: [0],
    });

    const passcodeControl = this.serviceNearDetailForm.get('jobDetailFormGroup')?.get('Pattern');
    const patternControl = this.serviceNearDetailForm.get('jobDetailFormGroup')?.get('PatternLock');

    passcodeControl?.valueChanges.subscribe(value => {
      if (value) {
        patternControl?.setValue('', { emitEvent: false });
      }
    });

    patternControl?.valueChanges.subscribe(value => {
      if (value) {
        passcodeControl?.setValue('', { emitEvent: false });
      }
    });

    this.subscription.add(merge(
      this.billForm.get('customDiscount')!.valueChanges,
      this.billForm.get('serviceDiscount')!.valueChanges,
      this.billForm.get('partsDiscount')!.valueChanges,
      this.billForm.get('newAdvance')!.valueChanges,
      this.serviceProductsArray.valueChanges,
      this.inventoryProductsArray.valueChanges
    ).pipe(debounceTime(300))
      .subscribe(() => {
        const total = this.finalAmount;
        this.billForm.get('finalAmt')!.setValue(total, { emitEvent: false });
        if (this.billForm.touched || this.billForm.dirty) {
          this.currentOrderStatus = OrderStatus.UnsavedChanges;
        }
      }));

    this.subscription.add(this.billForm.get('finalAmt')!.valueChanges
      .pipe(
        debounceTime(700),
        distinctUntilChanged()
      ).subscribe(val => {
        // Cancel any previous countdown if user keeps typing
        this.clearCountdown();
        this.showFinalAmtSaveBtn = true;
        // Start countdown for 3 seconds
        this.startCountdown(3, () => {
          this.runFinalAmountUpdate(val);
        });
        if (this.billForm.touched || this.billForm.dirty) {
          this.currentOrderStatus = OrderStatus.UnsavedChanges;
        }
      }));

    this.RefundForm = this.fb.group({
      amount: ['', [Validators.required]],
      returnProducts: this.fb.array([]),
      isRefundWithReturn: [false],
    })

    this.subscription.add(this.returnProductsArray.valueChanges.subscribe(value => {
      this.calculateReturnTotals();
    }));

    this.quickAddProductForm = this.fb.group({
      ProductName: ['', Validators.required],
      QtyInput: [1, [Validators.required, Validators.min(1)]],
      FinalPrice: ["", [Validators.pattern("^([0-9]{0,8})$")]],
      ProductType: ['service'], // default, will be set on open
      MRP: ["", [Validators.required, Validators.pattern("^([0-9]{0,8})$")]],
      PurchasePrice: ["", [Validators.pattern("^([0-9]{0,8})$")]],
      UnitPrice: ["", [Validators.required, Validators.pattern("^([0-9]{0,8})$")]],
      Discount: ["", [Validators.pattern("^([0-9]+)$")]],
      DiscountPercent: ["", [Validators.pattern("^([0-9]|[1-9]?[0-9]|100)$")]],
      mrpDiscount: ["", [Validators.pattern("^([0-9]+)$")]],
      mrpDiscountPercent: ["", [Validators.pattern("^([0-9]|[1-9]?[0-9]|100)$")]],
    });

    // register listeners to keep quick add fields in sync
    this.addQuickProductFormListeners();

    this.subscription.add(this.billForm.get('serviceSearch')!.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      tap(() => { this.isSearching = true; }),
      switchMap((str: string) => {
        this.paramsService.keyword = str;
        this.thirdPartyService.setSearchKeyword(str);
        return this.thirdPartyService.getProductList(this.paramsService);
      })).subscribe((res: any) => {
        this.isSearching = false;
        this.serviceProducts = res.ResponseData;
        this.thirdPartyService.setProductListCache(res.ResponseData, res.RowCount);
      }));
    this.subscription.add(this.billForm.get('partsSearch')!.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      tap(() => { this.isSearching = true; }),
      switchMap((str: string) => {
        this.paramsInventory.keyword = str;
        this.thirdPartyService.setSearchKeyword(str);
        return this.thirdPartyService.getProductList(this.paramsInventory);
      })).subscribe((res: any) => {
        this.isSearching = false;
        this.inventoryProducts = res.ResponseData;
        this.thirdPartyService.setProductListCache(res.ResponseData, res.RowCount);
      }));
  }

  onPatternComplete(pattern: number[]) {
    this.serviceNearDetailForm.get('jobDetailFormGroup')?.get('PatternLock')?.setValue(pattern);
  }

  private runFinalAmountUpdate(val: number) {
    this.isFinalAmountEdited = true;
    this.prevFinalAmount = this.finalAmount;
    const index = this.serviceProductsArray.controls.findIndex(ctrl => {
      const productId = ctrl.get('ProductID')?.value;
      const id = ctrl.get('ID')?.value;
      return productId === this.defaultID || id === this.defaultID;
    });

    if (index !== -1) {
      // Service Charge exists - update
      const serviceCharge = this.serviceProductsArray.at(index) as FormGroup;
      let newServiceCharge = val - this.finalAmount + serviceCharge.value?.FinalPrice;
      if (newServiceCharge < 0) {
        newServiceCharge = 0;
      }
      this.serviceProductsArray.at(index).patchValue({
        QtyInput: 1,
        FinalPrice: newServiceCharge,
        TotalPrice: newServiceCharge,
      });

    } else {
      // Service Charge does not exist - add
      let newServiceCharge = val - this.finalAmount;
      if (newServiceCharge < 0) {
        newServiceCharge = 0;
      }
      this.defaultProduct.addControl('orderdetailID', new FormControl(0));
      if (this.defaultProduct) {
        this.defaultProduct.patchValue({
          QtyInput: 1,
          FinalPrice: newServiceCharge,
          TotalPrice: newServiceCharge,
          orderdetailID: this.defaultProductOrderDetailID,
        }, { emitEvent: false });
      }
      this.serviceProductsArray.push(this.defaultProduct);
    }
    this.showFinalAmtSaveBtn = false;
  }

  private startCountdown(seconds: number, onComplete: () => void) {
    this.counter = seconds;
    this.isCountingDown = true;

    // Every second → update counter
    this.counterInterval = setInterval(() => {
      this.counter--;
      if (this.counter <= 0) {
        this.clearCountdown();
        onComplete();
      }
    }, 1000);
  }

  private clearCountdown() {
    if (this.counterInterval) clearInterval(this.counterInterval);
    this.counter = 0;
    this.isCountingDown = false;
  }

  public onFinalAmountSave() {
    const val = this.billForm.get('finalAmt')!.value;
    this.clearCountdown();       // Stop countdown
    this.runFinalAmountUpdate(val);  // Run immediately
  }


  public udpateWorkStatus() {
    this.isLoading = true;
    const selectedStatus = this.serviceNearDetailForm.get('workStatusFormGroup.WorkStatus')?.value;
    if (selectedStatus) {
      this.updationParams.workStatus = selectedStatus;
      this.updationParams.workDescription = this.serviceNearDetailForm.get('workStatusFormGroup.currentStatusOfDevice')?.value;
      this.updationParams.customerDescription = this.serviceNearDetailForm.get('workStatusFormGroup.messageCustomer')?.value;
    }
    this.subscription.add(this.thirdPartyService.updateWorkOrderStatusByBranchType(this.updationParams).subscribe((res: any) => {
      if (res && res?.Result == "Success" && res?.ResponseData) {

        if (selectedStatus == 'Delivered') {
          this.page = 3;
          setTimeout(() => {
            this.goToPaymentAccordion();
          }, 1000);
        } else if (selectedStatus == 'Service Completed') {
          this.page = 3;
          setTimeout(() => {
            this.goToPartsAccordion();
          }, 1000);
        }

        this.setFilteredStatusList();
        this.updateWorkOrderForStatus();
        this.isLoading = false;
        this.configService.notify({
          severity: 'success',
          summary: 'Success',
          detail: `Status changed succesfully.`,
        });
      }
    }, (error: HttpErrorResponse) => {
      this.isLoading = false;
    }));
  }

  public clearUser() {
    this.currentAssignedUser = '';
    this.serviceNearDetailForm.get('workStatusFormGroup.AssignedUser')?.setValue('');
  }

  public handleAssignedUserChange(user: any) {
    this.currentAssignedUser = user.Name;
    this.serviceNearDetailForm.get('workStatusFormGroup.AssignedUser')?.setValue(this.currentAssignedUser);
  }

  private finalPriceLessThanMRPValidator(form: FormGroup) {
    const finalPrice = form.get('FinalPrice')?.value;
    const mrp = form.get('MRP')?.value;

    if (finalPrice != null && mrp != null && finalPrice > mrp) {
      return { finalPriceGreaterThanMRP: true };
    }

    return null;
  }

  private getServices() {
    this.subscription.add(this.thirdPartyService.getProductList(this.paramsService).subscribe((res: any) => {
      if (res && res?.Result == "Success" && res?.ResponseData) {
        this.serviceProducts = res.ResponseData;
        this.defaultID = this.serviceProducts[0]?.ID
        this.serviceProductsLength = res.RowCount;
        this.filteredServicesList = [...this.serviceProducts];
        const serviceProductsArray = this.billForm.get('serviceProducts') as FormArray;
        const inventoryProductsArray = this.billForm.get('inventoryProducts') as FormArray;
        if (this.serviceProducts.length > 0 && serviceProductsArray.length === 0 && inventoryProductsArray.length === 0) {
          const firstProduct = this.serviceProducts[0];
          const group = this.fb.group({
            ID: [firstProduct.ID],
            ProductName: [firstProduct.ProductName],
            MRP: [firstProduct.MRP],
            QtyInput: [firstProduct.QtyInput || 1, [Validators.required, Validators.min(1)]],
            FinalPrice: [firstProduct.FinalPrice],
            Image: [firstProduct.Image],
            TotalPrice: [firstProduct.FinalPrice * (firstProduct.QtyInput || 1)],
            PurchasePrice: [firstProduct.PurchasePrice],
            CategoryName: [firstProduct.CategoryName],
            ProductType: [firstProduct.ProductType],
            ProductDiscount: [firstProduct.ProductDiscount || 0],
          });
          this.defaultProduct = group;
          serviceProductsArray.push(group);
          this.originalServiceProducts = this.serviceProductsArray.value.map((x: any) => ({ ...x }));
        }
      }
    }, (error: HttpErrorResponse) => {
      this.isLoading = false;
    }));
  }

  private getInventoryProducts() {
    this.subscription.add(this.thirdPartyService.getProductList(this.paramsInventory).subscribe((res: any) => {
      if (res && res?.Result == "Success" && res?.ResponseData) {
        this.inventoryProducts = res.ResponseData;
        this.inventoryProductsLength = res.RowCount;
        this.filteredInventoryList = [...this.inventoryProducts];
      }
    }, (error: HttpErrorResponse) => {
      this.isLoading = false;
    }));
  }

  public addToServiceList(item: any, index: number, quickProduct: boolean = false) {
    if (quickProduct) {
      const group = this.fb.group({
        ID: [null],
        ProductName: [item.ProductName],
        MRP: [item.MRP || 0],
        QtyInput: [item.QtyInput || 1],
        FinalPrice: [item.FinalPrice],
        UnitPrice: [item.UnitPrice],
        Image: [item.Image || ''],
        TotalPrice: [item.FinalPrice * (item.QtyInput || 1)],
        PurchasePrice: [item.PurchasePrice || 0],
        CategoryName: [item.CategoryName || ''],
        ProductType: [item.ProductType],
        ProductDiscount: [item.Discount || 0],
        MRPDiscount: [item.mrpDiscount || 0],
      });
      this.serviceProductsArray.push(group);
    } else {
      const idx = this.serviceProductsArray.controls.findIndex(ctrl => ctrl.value.ID === item.ID || ctrl.value.ProductID === item.ID);
      if (idx !== -1) {
        if (!this.privilegeService.getServicenearPrivilege('serviceEditOnJob', true)) {
          return;
        }
        const group = this.serviceProductsArray.at(idx) as FormGroup;
        if (group.value.ProductID == this.defaultID) {
          this.isServiceDropdownOpen = false;
          return;
        }
        const currentQty = group.get('QtyInput')?.value || 1;
        group.get('QtyInput')?.setValue(currentQty + 1);
        const finalPrice = group.get('FinalPrice')?.value || item.FinalPrice;
        group.get('TotalPrice')?.setValue(finalPrice * (currentQty + 1));
      } else {
        const group = this.fb.group({
          ID: [item.ID],
          ProductName: [item.ProductName],
          MRP: [item.MRP],
          QtyInput: [item.QtyInput || 1, [Validators.required, Validators.min(1)]],
          DiscountPercentage: [
            ((item.UnitPrice - item.FinalPrice) / item.UnitPrice) * 100 || 0,
          ],
          MRPDiscountPercentage: [
            ((item.MRP - item.FinalPrice) / item.MRP) * 100 || 0,
          ],
          DiscountAmount: [item.UnitPrice - item.FinalPrice],
          MRPDiscountAmount: [item.MRP - item.FinalPrice],
          UnitPrice: [item.UnitPrice],
          FinalPrice: [item.FinalPrice],
          Image: [item.Image],
          TotalPrice: [item.FinalPrice * (item.QtyInput || 1)],
          PurchasePrice: [item.PurchasePrice],
          CategoryName: [item.CategoryName],
          ProductType: [item.ProductType],
          ProductDiscount: [item.ProductDiscount || 0],
          Stock: [item.Stock],
          orderdetailID: [item.orderdetailID],
        });
        this.serviceProductsArray.push(group);
      }
    }
    this.isServiceDropdownOpen = false;
    this.showMoreFields = false;
  }

  public isOriginalServiceProduct(id: any): boolean {
    return this.defaultID === id;
  }

  public addToPartsList(item: any, index: number, quickProduct: boolean = false) {
    if (quickProduct) {
      const group = this.fb.group({
        ID: [null],
        ProductName: [item.ProductName],
        MRP: [item.MRP || 0],
        QtyInput: [item.QtyInput || 1],
        UnitPrice: [item.UnitPrice],
        FinalPrice: [item.FinalPrice],
        Image: [item.Image || ''],
        TotalPrice: [item.FinalPrice * (item.QtyInput || 1)],
        PurchasePrice: [item.PurchasePrice || 0],
        CategoryName: [item.CategoryName || ''],
        ProductType: [item.ProductType],
        ProductDiscount: [item.Discount || 0],
        MRPDiscount: [item.mrpDiscount || 0],
      });
      this.inventoryProductsArray.push(group);
    } else {
      const idx = this.inventoryProductsArray.controls.findIndex(ctrl => ctrl.value.ID === item.ID || ctrl.value.ProductID === item.ID);
      if (idx !== -1) {
        if (!this.privilegeService.getServicenearPrivilege('partsEditOnJob', true)) {
          return;
        }
        const group = this.inventoryProductsArray.at(idx) as FormGroup;
        const currentQty = group.get('QtyInput')?.value || 1;
        group.get('QtyInput')?.setValue(currentQty + 1);
        const finalPrice = group.get('FinalPrice')?.value || item.FinalPrice;
        group.get('TotalPrice')?.setValue(finalPrice * (currentQty + 1));
      } else {

        const group = this.fb.group({
          ID: [item.ID],
          ProductName: [item.ProductName],
          MRP: [item.MRP],
          QtyInput: [item.QtyInput || 1, [Validators.required, Validators.min(1)]],
          DiscountPercentage: [
            ((item.UnitPrice - item.FinalPrice) / item.MRP) * 100 || 0,
          ],
          MRPDiscountPercentage: [
            ((item.MRP - item.FinalPrice) / item.MRP) * 100 || 0,
          ],
          DiscountAmount: [item.UnitPrice - item.FinalPrice],
          MRPDiscountAmount: [item.MRP - item.FinalPrice],
          UnitPrice: [item.UnitPrice],
          FinalPrice: [item.FinalPrice],
          Image: [item.Image],
          TotalPrice: [item.FinalPrice * (item.QtyInput || 1)],
          PurchasePrice: [item.PurchasePrice],
          CategoryName: [item.CategoryName],
          ProductType: [item.ProductType],
          ProductDiscount: [item.ProductDiscount || 0],
          Stock: [item.Stock],
          orderdetailID: [item.orderdetailID],
        });
        this.inventoryProductsArray.push(group);
      }
    }
    this.isPartsDropdownOpen = false;
    this.showMoreFields = false;
  }

  get serviceProductsArray(): FormArray {
    return this.billForm.get('serviceProducts') as FormArray;
  }

  get inventoryProductsArray(): FormArray {
    return this.billForm.get('inventoryProducts') as FormArray;
  }

  get returnProductsArray(): FormArray {
    return this.RefundForm.get('returnProducts') as FormArray;
  }

  get selectedProducts() {
    return this.returnProductsArray.controls
      .filter((ctrl) => ctrl.get('isSelected')?.value)
      .map((ctrl) => ctrl.value);
  }

  get isReturnProductsSelected(): boolean {
    const selected = this.returnProductsArray.value.filter(item => item.isSelected);
    return selected.length > 0;
  }

  public removeServiceProduct(item: any, index: number) {
    if (index !== -1) {
      this.serviceProductsArray.removeAt(index);
    }
  }

  public removeInventoryProduct(item: any, index: number) {
    const idx = this.inventoryProductsArray.controls.findIndex(ctrl => ctrl.value.ID === item.ID);
    if (idx !== -1) {
      this.inventoryProductsArray.removeAt(idx);
    }
  }

  public editServiceProduct(item: any, index: number) {
    this.editingProductType = 'service';
    this.editingProductIndex = index;
    const discountRupees = Number(item.ProductDiscount) || 0;
    const discountPercent = (discountRupees / item.MRP) * 100 || 0;
    this.editingProductForm = this.fb.group({
      ID: [item.ID],
      ProductName: [item.ProductName],
      MRP: [item.MRP],
      QtyInput: [item.QtyInput || 1, [Validators.required, Validators.min(1)]],
      DiscountPercent: [discountPercent, [Validators.min(0), Validators.max(100)]],
      Discount: [discountRupees, [Validators.min(0), Validators.max(item.FinalPrice)]],
      FinalPrice: [item.FinalPrice],
      Image: [item.Image],
      TotalPrice: [item.FinalPrice * (item.QtyInput || 1)]
    });

    if (item.ProductID === this.defaultID || item.ID === this.defaultID) {
      this.editingProductForm.get('QtyInput')?.disable();
    }
    this.prevMRP = item.MRP;
    this.addListenersForProductEdit(item);
    this.showProductEditModal = true;
  }

  public editInventoryProduct(item: any, index: number) {
    this.editingProductType = 'inventory';
    this.editingProductIndex = index;
    const discountRupees = Number(item.ProductDiscount) || 0;
    const discountPercent = (discountRupees / item.MRP) * 100 || 0;
    this.editingProductForm = this.fb.group({
      ID: [item.ID],
      ProductName: [item.ProductName],
      MRP: [item.MRP],
      QtyInput: [item.QtyInput || 1, [Validators.required, Validators.min(1)]],
      DiscountPercent: [discountPercent, [Validators.max(100)]],
      Discount: [discountRupees, [Validators.max(item.FinalPrice)]],
      FinalPrice: [item.FinalPrice],
      Image: [item.Image],
      TotalPrice: [item.FinalPrice * (item.QtyInput || 1)],
      PurchasePrice: [item.PurchasePrice],
    });

    this.prevMRP = item.MRP;
    this.addListenersForProductEdit(item);
    this.showProductEditModal = true;
  }

  private getProductID = (item) => item.ProductID ?? item.ID;

  private addListenersForProductEdit(item: any): void {
    const form = this.editingProductForm;
    const mrp = form.get('MRP').value;

    const qtyControl = form.get('QtyInput')!;
    const discountPercentControl = form.get('DiscountPercent')!;
    const discountRupeesControl = form.get('Discount')!;
    const finalPriceControl = form.get('FinalPrice')!;
    const totalPriceControl = form.get('TotalPrice')!;
    const mrpControl = form.get('MRP')!;

    const patchForm = (values: any) => form.patchValue(values, { emitEvent: false });

    const calculateFromPercent = (percent: number) => {
      const validPercent = Math.min(Math.max(percent, 0), 100);
      const discountRupees = (mrp * validPercent) / 100;
      const finalPrice = mrp - discountRupees;
      const qty = qtyControl.value || 1;

      patchForm({
        Discount: discountRupees.toFixed(2),
        FinalPrice: finalPrice.toFixed(2),
        TotalPrice: (finalPrice * qty).toFixed(2)
      });
    };

    const calculateFromRupees = (rupees: number) => {
      const validRupees = Math.min(Math.max(rupees, 0), mrp);
      const percent = (validRupees / mrp) * 100;
      const finalPrice = mrp - validRupees;
      const qty = qtyControl.value || 1;

      patchForm({
        DiscountPercent: percent.toFixed(2),
        FinalPrice: finalPrice.toFixed(2),
        TotalPrice: (finalPrice * qty).toFixed(2)
      });
    };

    const calculateFromFinalPrice = (finalPrice: number) => {
      const validFinal = finalPrice;
      let discountRupees = mrp - validFinal;
      let percent = (discountRupees / mrp) * 100;
      if (discountRupees < 0) {
        discountRupees = 0;
        percent = 0;
      }
      const qty = qtyControl.value || 1;

      patchForm({
        DiscountPercent: percent.toFixed(2),
        Discount: discountRupees.toFixed(2),
        TotalPrice: (validFinal * qty).toFixed(2)
      });
    };

    const calculateFromMrp = (marpVal: number) =>{
      const validFinal = finalPriceControl.value || 0;
      let discountRupees = marpVal - validFinal;
      let percent = (discountRupees / marpVal) * 100;
      if (discountRupees < 0) {
        discountRupees = 0;
        percent = 0;
      }
      const qty = qtyControl.value || 1;

      patchForm({
        DiscountPercent: percent.toFixed(2),
        Discount: discountRupees.toFixed(2),
        TotalPrice: (validFinal * qty).toFixed(2)
      });
    }

    const calculateTotalPrice = (qty: number) => {
      const finalPrice = finalPriceControl.value || 0;
      patchForm({ TotalPrice: (finalPrice * qty).toFixed(2) });
    };

    this.subscription.add(discountPercentControl.valueChanges.subscribe(percent => {
      if (percent === null || percent === '') {
        patchForm({ Discount: '' });
        return;
      }
      calculateFromPercent(+percent);
    }));

    this.subscription.add(discountRupeesControl.valueChanges.subscribe(rupees => {
      if (rupees === null || rupees === '') {
        patchForm({ DiscountPercent: '' });
        return;
      }
      calculateFromRupees(+rupees);
    }));

    this.subscription.add(finalPriceControl.valueChanges.subscribe(finalPrice => {
      if (finalPrice === null || finalPrice === '') {
        patchForm({ DiscountPercent: '', Discount: '', TotalPrice: '' });
        return;
      }
      calculateFromFinalPrice(+finalPrice);
    }));

    this.subscription.add(mrpControl.valueChanges.subscribe(mrpVal => {
      if (mrpVal === null || mrpVal === '') {
        patchForm({ DiscountPercent: '', Discount: '', TotalPrice: '' });
        return;
      }
      calculateFromMrp(+mrpVal);
    }))

    this.subscription.add(qtyControl.valueChanges.subscribe(qty => {
      if (qty === null || qty === '') return;
      calculateTotalPrice(+qty);
    }));
  }


  increaseQty() {
    const control = this.editingProductForm.get('QtyInput');
    if (control) {
      const current = control.value || 0;
      control.setValue(current + 1);
    }
  }

  decreaseQty() {
    const control = this.editingProductForm.get('QtyInput');
    if (control) {
      const current = control.value || 0;
      if (current > 1) {
        control.setValue(current - 1);
      }
    }
  }


  public getTotalServiceMRP(): number {
    return this.serviceProductsArray?.controls?.reduce((total, ctrl) => {
      const item = ctrl.value;
      const qty = item.QtyInput ?? 1;
      return total + (item.FinalPrice * qty);
    }, 0);
  }

  public getTotalInventoryMRP(): number {
    return this.inventoryProductsArray?.controls?.reduce((total, ctrl) => {
      const item = ctrl.value;
      const qty = item.QtyInput ?? 1;
      return total + (item.FinalPrice * qty);
    }, 0);
  }

  public incrementQty(group: FormGroup, event: Event): void {
    event.stopPropagation();
    const qtyControl = group.get('QtyInput');
    const unitControl = group.get('FinalPrice');
    const totalControl = group.get('TotalPrice');
    if (qtyControl) {
      const currentQty = Number(qtyControl.value) || 1;
      qtyControl.setValue(currentQty + 1);
      const totalPrice = unitControl.value * (currentQty + 1);
      totalControl.setValue(totalPrice);
    }
  }

  public decrementQty(group: FormGroup, event: Event): void {
    event.stopPropagation();
    const qtyControl = group.get('QtyInput');
    const unitControl = group.get('FinalPrice');
    const totalControl = group.get('TotalPrice');
    if (qtyControl) {
      const currentQty = Number(qtyControl.value) || 1;
      if (currentQty > 1) {
        qtyControl.setValue(currentQty - 1);
        const totalPrice = unitControl.value * (currentQty - 1);
        totalControl.setValue(totalPrice);
      }
    }
  }

  public onTotalPriceChange(group: FormGroup): void {
    const totalPriceControl = group.get('TotalPrice');
    const qtyControl = group.get('QtyInput');
    const finalPriceControl = group.get('FinalPrice');
    if (totalPriceControl && qtyControl && finalPriceControl) {
      const totalPrice = Number(totalPriceControl.value) || 0;
      const qty = Number(qtyControl.value) || 1;
      const newFinalPrice = totalPrice / qty;
      finalPriceControl.setValue(newFinalPrice, { emitEvent: false });
    }
  }

  get totalDiscount(): number {
    const customDiscount = parseFloat(this.billForm.get('customDiscount')?.value) || 0;
    const partsDiscount = parseFloat(this.billForm.get('partsDiscount')?.value) || 0;
    const serviceDiscount = parseFloat(this.billForm.get('serviceDiscount')?.value) || 0;
    return customDiscount + partsDiscount + serviceDiscount;
  }

  get customDiscount(): number {
    return this.billForm.get('customDiscount')?.value || 0;
  }

  get serviceDiscount(): number {
    return this.billForm.get('serviceDiscount')?.value || 0;
  }

  get partsDiscount(): number {
    return this.billForm.get('partsDiscount')?.value || 0;
  }

  get assignedUser(): string {
    return this.serviceNearDetailForm.get('workStatusFormGroup.AssignedUser')?.value || '';
  }

  get isPaidJob() {
    let isNotPaid: boolean = false;
    if (this.salesDetails) {
      isNotPaid = true;
    }
    if (this.salesDetails?.header?.OrderStatus == "Placed") {
      isNotPaid = false;
    }
    return isNotPaid
  }

  get refundAmount() {
    return this.RefundForm.get('amount')?.value || 0;
  }

  get isAdvanceEdited() {
    if (this.editAdvancedPaymentInfo) {
      return this.editAdvancedPaymentInfo.totalReceivedAmount != this.prevAdvanceAmount;
    }
    return false;
  }

  get isMRPEdited() {
    if(this.editingProductForm.get('MRP').value != this.prevMRP){
      return true;
    }
    return false;
  }

  private populateToolbarData() {
    this.layoutService.setToolbar({
      title: 'Details',
      isShopService: false,
    });

    this.layoutService.setNavbarButtons([
      { action: 'call', state: null, icon: 'call' },
    ]);

    this.subscription.add(this.layoutService.buttonClicked$.subscribe((btn: NavbarBtn) => {
      
      if (!btn) return;

      switch (btn.action) {
        case 'call':
          this.callNumber(this.jobDetails[0]?.ContactNo);
          break;
      }
    }));
  }

  public changePage(page: number) {
    this.page = page;
    if (this.salesDetails?.header?.OrderStatus === 'Delivered') {
      setTimeout(() => {
        this.goToPaymentAccordion();
      }, 0);
    }
  }

  public updateWorkOrder() {
    let newAssignedUserID = this.userList.find((item: any) => {
      return item.Name === this.serviceNearDetailForm.get('jobDetailFormGroup')?.get('AssignedUser')?.value;
    });
    let newAssignedUser = this.serviceNearDetailForm.get('jobDetailFormGroup')?.get('AssignedUser')?.value;
    const accessoriesData = this.serviceNearDetailForm.get('jobDetailFormGroup')?.get('accessories')?.value;
    // const patternLock = this.serviceNearDetailForm.get('jobDetailFormGroup')?.get('PatternLock')?.value;
    // accessoriesData.PatternLock = patternLock;
    let devicePass;

    if(this.serviceNearDetailForm.get('jobDetailFormGroup')?.get('PatternLock')?.value){
      devicePass = {
        pat: this.serviceNearDetailForm.get('jobDetailFormGroup')?.get('PatternLock')?.value
      }
    }else if(this.serviceNearDetailForm.get('jobDetailFormGroup')?.get('Pattern')?.value){
      devicePass = {
        pas: this.serviceNearDetailForm.get('jobDetailFormGroup')?.get('Pattern')?.value
      }
    }



    const accessoriesDataString = JSON.stringify(accessoriesData);
    let updateWorkOrderParams = {
      id: this.workId,
      branchID: this.branchID,
      updatedBy: "",
      shopName: this.serviceNearDetailForm.get('jobDetailFormGroup')?.get('ShopName')?.value,
      manufacture: this.serviceNearDetailForm.get('jobDetailFormGroup')?.get('Manufacture')?.value,
      modelName: this.serviceNearDetailForm.get('jobDetailFormGroup')?.get('ModelName')?.value,
      workDescription: this.serviceNearDetailForm.get('jobDetailFormGroup')?.get('WorkDescription')?.value,
      pattern: devicePass ? JSON.stringify(devicePass): '',
      createdOn: "",
      deliveryDate: this.serviceNearDetailForm.get('jobDetailFormGroup')?.get('DeliveryDate')?.value,
      updatedOn: "",
      imei: this.serviceNearDetailForm.get('jobDetailFormGroup')?.get('IMEI')?.value,
      accessories: accessoriesDataString,
      contactPerson: this.serviceNearDetailForm.get('jobDetailFormGroup')?.get('ContactPerson')?.value,
      contactNo: this.serviceNearDetailForm.get('jobDetailFormGroup')?.get('ContactNo')?.value,
      emailID: this.serviceNearDetailForm.get('jobDetailFormGroup')?.get('EmailID')?.value,
      contactAddress: this.serviceNearDetailForm.get('jobDetailFormGroup')?.get('ContactAddress')?.value,
      minServiceCost: this.serviceNearDetailForm.get('jobDetailFormGroup')?.get('MinServiceCost')?.value,
      maxServiceCost: this.serviceNearDetailForm.get('jobDetailFormGroup')?.get('MaxServiceCost')?.value,
      advanceServiceCost: this.serviceNearDetailForm.get('jobDetailFormGroup')?.get('AdvanceServiceCost')?.value,
      serviceCost: "",
      assignedUserID: newAssignedUserID?.UserID,
      assignedUser: newAssignedUser,
      deviceType: this.serviceNearDetailForm.get('jobDetailFormGroup')?.get('DeviceType')?.value,
      assignedUserName: "",
      branchType: "",
      deviceImage: "",
      approvedAmount: 0,
      cost: 0,
      payment: 0,
      discount: 0,
      balance: 0,
      changeOnly: true
    }
    if (this.serviceNearDetailForm.get('jobDetailFormGroup').valid) {
      this.subscription.add(this.thirdPartyService.updateWorkOrderByBranchType(updateWorkOrderParams).subscribe((res: any) => {
        if (res && res?.Result == "Success" && res?.ResponseData) {
          this.getServiceInfo();
        }
      }, (error: HttpErrorResponse) => {
        this.isLoading = false;
      }));
      this.isEditMode = false;
    }
  }

  public updateWorkOrderForStatus() {
    let newAssignedUserID = this.userList.find((item: any) => {
      return item.Name === this.serviceNearDetailForm.get('workStatusFormGroup')?.get('AssignedUser')?.value;
    });
    let newAssignedUser = this.serviceNearDetailForm.get('workStatusFormGroup')?.get('AssignedUser')?.value;

    const accessoriesData = this.serviceNearDetailForm.get('jobDetailFormGroup')?.get('accessories')?.value;
    const accessoriesDataString = JSON.stringify(accessoriesData);
    let devicePass;

    if (this.jobDetails[0]?.Pattern) {
      devicePass = JSON.parse(this.jobDetails[0]?.Pattern);
    }
    let updateWorkOrderParams = {
      id: this.workId,
      branchID: this.branchID,
      updatedBy: "",
      shopName: this.serviceNearDetailForm.get('jobDetailFormGroup')?.get('ShopName')?.value,
      manufacture: this.serviceNearDetailForm.get('jobDetailFormGroup')?.get('Manufacture')?.value,
      modelName: this.serviceNearDetailForm.get('jobDetailFormGroup')?.get('ModelName')?.value,
      workDescription: this.serviceNearDetailForm.get('jobDetailFormGroup')?.get('WorkDescription')?.value,
      pattern: devicePass ? JSON.stringify(devicePass): '',
      createdOn: "",
      deliveryDate: this.serviceNearDetailForm.get('jobDetailFormGroup')?.get('DeliveryDate')?.value,
      updatedOn: "",
      imei: this.serviceNearDetailForm.get('jobDetailFormGroup')?.get('IMEI')?.value,
      accessories: accessoriesDataString,
      contactPerson: this.serviceNearDetailForm.get('jobDetailFormGroup')?.get('ContactPerson')?.value,
      contactNo: this.serviceNearDetailForm.get('jobDetailFormGroup')?.get('ContactNo')?.value,
      emailID: this.serviceNearDetailForm.get('jobDetailFormGroup')?.get('EmailID')?.value,
      contactAddress: this.serviceNearDetailForm.get('jobDetailFormGroup')?.get('ContactAddress')?.value,
      minServiceCost: this.serviceNearDetailForm.get('jobDetailFormGroup')?.get('MinServiceCost')?.value,
      maxServiceCost: this.serviceNearDetailForm.get('jobDetailFormGroup')?.get('MaxServiceCost')?.value,
      advanceServiceCost: this.serviceNearDetailForm.get('jobDetailFormGroup')?.get('AdvanceServiceCost')?.value,
      serviceCost: "",
      assignedUserID: newAssignedUserID?.UserID,
      assignedUser: newAssignedUser,
      deviceType: this.serviceNearDetailForm.get('jobDetailFormGroup')?.get('DeviceType')?.value,
      assignedUserName: "",
      branchType: "",
      deviceImage: "",
      approvedAmount: 0,
      cost: 0,
      payment: 0,
      discount: 0,
      balance: 0,
      changeOnly: true
    }
    if (this.serviceNearDetailForm.get('jobDetailFormGroup').valid) {
      this.subscription.add(this.thirdPartyService.updateWorkOrderByBranchType(updateWorkOrderParams).subscribe((res: any) => {
        if (res && res?.Result == "Success" && res?.ResponseData) {
          this.getServiceInfo();
        }
      }, (error: HttpErrorResponse) => {
        this.isLoading = false;
      }));
      this.isEditMode = false;
    }
  }

  private getWorkStatusFormValue() {
    return JSON.parse(JSON.stringify(this.serviceNearDetailForm.get('workStatusFormGroup')?.getRawValue()));
  }

  public handleDiscard() {
    this.serviceNearDetailForm.get('workStatusFormGroup')?.setValue(this.workStatusFormInitialValue);
    this.handleWorkStatusChange(this.currentWorkStatus);
    this.currentAssignedUser = this.workStatusFormInitialValue.AssignedUser;
  }

  public handleWorkStatusChange(selectedStatus: any) {
    this.selectedWorkStatus = selectedStatus;
    this.serviceNearDetailForm.get('workStatusFormGroup.WorkStatus')?.setValue(selectedStatus);
  }

  private setFilteredStatusList() {
    const canMoveToList = this.statusAccess.find(
      s => s.status === this.selectedWorkStatus
    )?.canMoveTo || [];

    // Update the filtered list with disabled flags
    this.filteredStatusList = this.statusAccess.map(status => ({
      Status: status.status,
      disabled: !canMoveToList.includes(status.status),
    }));
    this.filteredStatusList.sort((a, b) => a.disabled - b.disabled);
  }

  isWorkStatusFormChanged(): boolean {
    const current = this.serviceNearDetailForm.get('workStatusFormGroup')?.getRawValue();
    return Object.keys(current).some(
      key => current[key] !== this.originalWorkStatusValues[key]
    );
  }

  private getFormValueSuggesstions() {
    this.subscription.add(this.thirdPartyService.getDeviceTypesByBranchType().subscribe((res: any) => {
      this.deviceTypes = res.ResponseData;
      localStorage.setItem('deviceTypes', JSON.stringify(this.deviceTypes));
    }, (error: HttpErrorResponse) => {
    }));
    this.subscription.add(this.thirdPartyService.getPhoneModelNamesByBranchType().subscribe((res: any) => {
      this.modelNames = res.ResponseData;
      localStorage.setItem('modelNames', JSON.stringify(this.modelNames));
    }, (error: HttpErrorResponse) => {
    }));
    this.subscription.add(this.thirdPartyService.getPhoneNamesByBranchType().subscribe((res: any) => {
      this.phoneNames = res.ResponseData;
      localStorage.setItem('phoneNames', JSON.stringify(this.phoneNames));
    }, (error: HttpErrorResponse) => {
    }));
  }

  public addDeviceTypeTagFn(term: string) {
    return { DeviceType: term };
  }

  public addPhoneNamesTagFn(term: string) {
    return { BranchType: 'Computer', ManufactureName: term };
  }

  public addModelNamesTagFn(term: string) {
    return { BranchType: 'Computer', ModelName: term };
  }

  get finalAmount(): number {
    const serviceMRP = +this.getTotalServiceMRP() || 0;
    const inventoryMRP = +this.getTotalInventoryMRP() || 0;
    const serviceDiscount = +this.serviceDiscount || 0;
    const partsDiscount = +this.partsDiscount || 0;
    const customDiscount = +this.customDiscount || 0;
    const advancePaid = this.billForm.get('newAdvance')?.value || 0;
    let total = Number(serviceMRP) + Number(inventoryMRP) - Number(serviceDiscount) - Number(partsDiscount) - Number(customDiscount) - Number(advancePaid);
    if (total < 0) {
      return 0;
    }
    return total;
  }

  get finalAmountWithoutAdditionalDisc(): number {
    const serviceMRP = +this.getTotalServiceMRP() || 0;
    const inventoryMRP = +this.getTotalInventoryMRP() || 0;
    const serviceDiscount = +this.serviceDiscount || 0;
    const partsDiscount = +this.partsDiscount || 0;
    const advancePaid = this.billForm.get('newAdvance')?.value || 0;
    let total = Number(serviceMRP) + Number(inventoryMRP) - Number(serviceDiscount) - Number(partsDiscount) - Number(advancePaid);
    if (total < 0) {
      return 0;
    }
    return total;
  }

  public async onSubmit(paymentInfo: any) {
    const serviceProducts = this.billForm.get('serviceProducts')!.value || [];
    const inventoryProducts = this.billForm.get('inventoryProducts')!.value || [];
    this.allSelectedProducts = [...serviceProducts, ...inventoryProducts];
    const selectedPartsArray = [...inventoryProducts]
    const latest = this.jobDetails[0];

    const quickProducts = this.allSelectedProducts.filter(p => !p.ID);
    if (quickProducts.length > 0) {
      this.doHaveQuickProducts = true;
    }
    for (const product of quickProducts) {
      product.ID = await this.getQuickProductID(product);
    }
    const hasInvalidID = this.allSelectedProducts.some(
      p => p.ID === 0 || p.ID === null
    );

    if (hasInvalidID) {
      this.notify(false, 'Please remove last created products');
      return;
    }

    const allOriginalProducts = [...this.serviceProducts, ...this.inventoryProducts];
    let productUpdateArray = this.allSelectedProducts.filter(item1 => {
      const match = allOriginalProducts.find(item2 => this.getProductID(item2) === this.getProductID(item1));
      return match && match.MRP !== item1.MRP;
    });

    productUpdateArray = productUpdateArray.map((item: any) => ({
      productID: this.getProductID(item),
      mrp: item.MRP
    }))

    const orderDetailsArray = this.allSelectedProducts.map(product => ({
      userID: latest.SalesPOSUserID || 0,
      productID: product.ID,
      price: product.FinalPrice,
      quantity: product.QtyInput,
      createdBy: latest.SalesPOSUserID || 0,
      organisationID: 0,
      unknownUserKey: ''
    }));
    const serviceDiscount = this.billForm.get('serviceDiscount')?.value || 0;
    const partsDiscount = this.billForm.get('partsDiscount')?.value || 0;
    const customDiscount = this.billForm.get('customDiscount')?.value || 0;
    const discountData = { serviceDiscount, partsDiscount, customDiscount };
    const totalDiscount = this.totalDiscount;
    const discountString = JSON.stringify(discountData);
    var sendingDataP = {
      orderHeader: {
        totalDeliveryCharge: 0,
        grandTotalAmount: 0,
        productTotalAmount: this.finalAmount,
        CustomerName: latest.ContactPerson,
        CustomerPhone: latest.ContactNo,
        DeliveryAddress: 'NA',
        DeliveryPlace: 'NA',
        DeliveryLandMark: 'NA',
        DeliveryPincode: '',
        orderStatus: 'Delivered',
        pickFromDeliveryPlace: false,
        ItemsCount: serviceProducts.length + inventoryProducts.length,
        paymentType: 'COD',
        discountBreakdown: discountString,
        appliedDiscount: totalDiscount,
        updateThirdPartyOrder: true,
        serviceCost: this.getTotalServiceMRP(),
        partsQty: selectedPartsArray.length,
        partsCost: this.getTotalInventoryMRP(),
        branchId: String(this.branchID),
        workId: this.workId,
        userID: latest.SalesPOSUserID || 0,
        changeToReturned: paymentInfo.change,
        totalReceivedAmount: paymentInfo.totalCashReceived,
        paymentModes: paymentInfo.paymentModesString,
        advanceAmount: 0,
        saleType: 'service'
      },
      orderDetails: orderDetailsArray,
      productUpdateDetails: productUpdateArray,
    }
    if (this.allSelectedProducts.length > 0) {
      this.isApiCalling = true;
      this.subscription.add(this.thirdPartyService.CheckOutOrderForPOS(sendingDataP).subscribe(
        (res: any) => {
          if (res?.Result === 'Success' && res?.ResponseData.OrderNumber) {
            const OrderID = res?.ResponseData?.OrderID;
            this.successfulOrderNumber = res?.ResponseData?.OrderNumber;
            this.successfulBillNumber = res?.ResponseData?.BillNo;
            this.SalesPOSOrderID = OrderID;
            this.billForm.reset
            this.updateSalesPOSOrderID(this.workId, OrderID);
            this.getServiceInfo();
            this.getOrderDetails(OrderID);
            if (this.doHaveQuickProducts) {
              this.getInventoryProducts();
              this.getServices();
              this.doHaveQuickProducts = false;
            }
            this.isSaleSuccess = true;
          } else if(res?.Result === 'Success' && res?.ResponseData == "No Stock"){
             this.notify(false, 'Some of the products are out of stock. Please check and try again');
          }
          this.isApiCalling = false;
        },
        (error: any) => {
          this.isApiCalling = false;
        }
      ));
    }
    else {
      this.configService.notify({
        severity: 'error',
        summary: 'Error',
        detail: 'Please enter valid payment details.'
      })
    }
  }

  public async updateOrderWithDetailsForPOS(paymentInfo: any) {
    const diffs = this.getProductDiffs();

    const allAddedproducts = [...diffs.service.added, ...diffs.inventory.added];
    const allDeletedproducts = [...diffs.service.deleted, ...diffs.inventory.deleted];
    const allModifiedproducts = [...diffs.service.modified, ...diffs.inventory.modified];

    const quickProducts = allAddedproducts.filter(p => !p.ID);
    if (quickProducts.length > 0) {
      this.doHaveQuickProducts = true;
    }
    for (const product of quickProducts) {
      product.ID = await this.getQuickProductID(product);
    }

    const hasInvalidID = allAddedproducts.some(
      p => p.ID === 0 || p.ID === null
    );

    if (hasInvalidID) {
      this.notify(false, 'Please remove last created products');
      return;
    }

    const addedDetails = allAddedproducts.map(product => ({
      productID: product.ProductID || product.productID || product.ID,
      price: product.FinalPrice,
      quantity: product.QtyInput,
      mrp: product.MRP,
      totalPrice: Number(product.TotalPrice) || 0,
      purchasePrice: product.PurchasePrice || product.PurchaseValue || 0,
    }));
    const deletedDetails = allDeletedproducts.map(product => ({
      detailId: product.orderdetailID || 0,
      productID: product.ProductID || product.productID || product.ID,
      price: product.FinalPrice,
      quantity: product.QtyInput,
      mrp: product.MRP,
      totalPrice: Number(product.TotalPrice) || 0,
      purchasePrice: product.PurchasePrice || product.PurchaseValue || 0,
    }));
    const modifiedDetails = allModifiedproducts.map(product => ({
      detailId: product.orderdetailID || 0,
      productID: product.ProductID || product.productID || product.ID,
      price: product.FinalPrice,
      quantity: product.QtyInput,
      mrp: product.MRP,
      totalPrice: Number(product.TotalPrice) || 0,
      purchasePrice: product.PurchasePrice || product.PurchaseValue || 0,
    }));

    const serviceProducts = this.billForm.get('serviceProducts')!.value || [];
    const inventoryProducts = this.billForm.get('inventoryProducts')!.value || [];
    this.allSelectedProducts = [...serviceProducts, ...inventoryProducts];


    const allOriginalProducts = [...this.serviceProducts, ...this.inventoryProducts];
    let productUpdateArray = this.allSelectedProducts.filter(item1 => {
      const match = allOriginalProducts.find(item2 => this.getProductID(item2) === this.getProductID(item1));
      return match && match.MRP !== item1.MRP;
    });

    productUpdateArray = productUpdateArray.map((item: any) => ({
      productID: this.getProductID(item),
      mrp: item.MRP
    }))

    const selectedPartsArray = [...inventoryProducts]
    const latest = this.jobDetails[0];
    const serviceDiscount = this.billForm.get('serviceDiscount')?.value || 0;
    const partsDiscount = this.billForm.get('partsDiscount')?.value || 0;
    const customDiscount = this.billForm.get('customDiscount')?.value || 0;
    const discountData = { serviceDiscount, partsDiscount, customDiscount };
    const totalDiscount = this.totalDiscount;
    const discountString = JSON.stringify(discountData);

    let sendingData = {
      orderHeader: {
        id: latest.SalesPosOrderId,
        totalDeliveryCharge: 0,
        grandTotalAmount: 0,
        productTotalAmount: this.finalAmount,
        CustomerName: latest.ContactPerson,
        CustomerPhone: latest.ContactNo,
        DeliveryAddress: '',
        DeliveryPlace: '',
        DeliveryLandMark: '',
        DeliveryPincode: '',
        orderStatus: 'Delivered',
        pickFromDeliveryPlace: false,
        ItemsCount: serviceProducts.length + inventoryProducts.length,
        paymentType: 'COD',
        discountBreakdown: discountString,
        appliedDiscount: totalDiscount,
        updateThirdPartyOrder: true,
        serviceCost: this.getTotalServiceMRP(),
        partsQty: selectedPartsArray.length,
        partsCost: this.getTotalInventoryMRP(),
        branchId: String(this.branchID),
        workId: this.workId,
        userID: latest.SalesPOSUserID || 0,
        changeToReturned: paymentInfo.change,
        totalReceivedAmount: paymentInfo.totalCashReceived,
        paymentModes: paymentInfo.paymentModesString,
        advanceAmount: this.salesDetails?.header?.AdvanceAmount || 0,
        cartUniqueKey: this.salesDetails?.details[0]?.CartUniqueKey || '',
      },
      addedDetails: addedDetails,
      modifiedDetails: modifiedDetails,
      deletedDetails: deletedDetails,
      productUpdateDetails: productUpdateArray,
    }

    if (this.allSelectedProducts.length > 0) {
      this.isApiCalling = true;
      this.subscription.add(this.thirdPartyService.UpdateOrderWithDetailsForPOS(sendingData).subscribe(
        (res: any) => {
          if (res?.Result === 'Success' && res?.ResponseData === "Success") {
            this.getServiceInfo();
            this.notify(true, 'Updated successfully');
            if (this.doHaveQuickProducts) {
              this.getInventoryProducts();
              this.getServices();
              this.doHaveQuickProducts = false;
            }
          }
          this.isApiCalling = false;
        },
        (error: any) => {
          this.isLoading = false;
          this.isApiCalling = false;
        }
      ));
    }
    else {
      this.configService.notify({
        severity: 'error',
        summary: 'Error',
        detail: 'Please enter valid payment details.'
      })
    }
    this.handlePaymentModalClose();
  }

  private updateSalesPOSOrderID(workOrderId: number, salesPosOrderId: number,) {
    this.subscription.add(this.thirdPartyService.updateSalesPOSOrderID(workOrderId, salesPosOrderId).subscribe(
      (res: any) => {
        if (res?.Result === 'Success') {
          const latest = this.jobDetails[0];
          // this.getOrderDetails(salesPosOrderId);
        }
      }));
  }

  public getOrderDetails(orderId: any) {
    this.isLoading = true;
    this.subscription.add(this.thirdPartyService.getOrderDetails(orderId).subscribe(
      (res: any) => {
        this.isLoading = false;
        if (res.Result === 'Success' && res?.ResponseData) {
          this.salesDetails = res.ResponseData;
          if (this.salesDetails?.header?.OrderStatus === 'Delivered' && this.jobDetails[0]?.WorkStatus == 'Delivered') {
            this.page = 3;
            setTimeout(() => {
              this.goToPaymentAccordion();
            }, 1000);
          }
          this.prevPaymentInfo = JSON.stringify(this.salesDetails?.orderPaymentModels);
          if (this.salesDetails?.orderPaymentModels?.length > 0) {
            this.isOrderPaymentModels = true;
          }
          if (this.salesDetails?.orderPaymentModels?.length > 0) {
            const paymentModesValues = JSON.parse(this.salesDetails?.header?.PaymentModesValue)
            this.paidAmountOnJob = paymentModesValues.Card + paymentModesValues.Cash + paymentModesValues.UPI;
            const refundAmountPaid = this.salesDetails?.header?.RefundAmount || 0;
            this.RefundForm.get('amount')?.setValidators([
              Validators.required,
              Validators.max(this.paidAmountOnJob - refundAmountPaid)
            ]);
            this.RefundForm.get('amount').updateValueAndValidity();
          }
          const advance = this.salesDetails?.header?.AdvanceAmount || 0;
          this.prevAdvanceAmount = advance;
          this.billForm.get('newAdvance').setValue(advance);
          if (this.isPaidJob) {
            this.isCostAndPayDisabled = true;
          }
          if (this.salesDetails?.header?.PaymentModesValue) {
            const paymentModesValue = JSON.parse(this.salesDetails?.header?.PaymentModesValue);
            if (paymentModesValue?.Credit > 0) {
              this.doJobHaveCredit = true;
              this.currentCreditBalance = paymentModesValue?.Credit;
            }
          }
          const services = this.salesDetails?.details.filter((item: any) => item.ProductType === 'service');
          //Get default service product orderDetailsID if present
          if (services.length > 0) {
            const defaultProduct = services.find((item: any) => item.ProductID === this.defaultID);
            this.defaultProductOrderDetailID = defaultProduct?.orderdetailID || 0;
          }
          this.patchBillSummary();
          this.returnProductsArray.clear();
          this.getReturnableProductsQuantityByOrder();

          this.currentOrderStatus = this.getCurrentOrderStatus();
          this.billForm.markAsUntouched(); 
        }
      },
      (error: HttpErrorResponse) => {
        this.isLoading = false;
      }
    ));
    this.isFinalAmountEdited = false;
  }

  private createProductFormGroup(item: any): FormGroup {
    let discount = 0;
    if (item.MRP > item.FinalPrice) {
      discount = item.MRP - item.FinalPrice;
    }
    return this.fb.group({
      orderdetailID: [item.orderdetailID],
      ProductID: [item.ProductID],
      ProductName: [item.ProductName],
      CategoryName: [item.CategoryName],
      SellerName: [item.SellerName],
      Image: [item.Image],
      QtyInput: [item.Quantity],
      ProductType: [item.ProductType],
      TotalPrice: [item.TotalPrice || (item.Price * (item.Quantity)) || 0],
      Price: [item.Price || 0],
      PurchaseValue: [item.PurchaseValue || 0],
      ProfitValue: [item.ProfitValue || 0],
      ProductUnitPrice: [item.ProductUnitPrice || 0],
      ProductDiscount: [item.ProductDiscount || discount || 0],
      UserWiseDiscount: [item.UserWiseDiscount || 0],
      TotalUserWiseDiscount: [item.TotalUserWiseDiscount || 0],
      IsInventoryProduct: [item.IsInventoryProduct || false],
      ReviewID: [item.ReviewID || null],
      FinalPrice: [item.Price || 0],
      MRP: [item.MRP || 0],
    });
  }

  private createReturnProductFormGroup(item: any): FormGroup {
    const group = this.fb.group({
      orderdetailID: [item.orderdetailID],
      ProductID: [item.ProductID],
      ProductName: [item.ProductName],
      CategoryName: [item.CategoryName],
      QtyInput: [item.ReturnableQuantity, []],
      ProductType: [item.ProductType],
      TotalPrice: [item.TotalPrice || (item.Price * (item.ReturnableQuantity)) || 0],
      Price: [item.Price || 0],
      FinalPrice: [item.Price || 0],
      MRP: [item.MRP || 0],
      isSelected: [false],
      TotalQuantity: [item.ReturnableQuantity],
      ReturnStatus: [item.ReturnStatus],
    });

    this.subscription.add(group.get('isSelected')?.valueChanges.subscribe((selected: boolean) => {
      const qtyControl = group.get('QtyInput');
      if (selected) {
        qtyControl?.setValidators([
          Validators.required,
          Validators.min(1),
          Validators.max(item.ReturnableQuantity)
        ]);
      } else {
        qtyControl?.clearValidators();
      }
      qtyControl?.updateValueAndValidity({ emitEvent: false });
    }));

    return group;
  }


  private patchBillSummary() {
    let discountData = JSON.parse(this.salesDetails.header?.DiscountBreakdown || '{}');
    this.billForm.patchValue({
      serviceDiscount: discountData.serviceDiscount,
      partsDiscount: discountData.partsDiscount,
      customDiscount: discountData.customDiscount,
    });
    const serviceProductsArray = this.billForm.get('serviceProducts') as FormArray;
    const inventoryProductsArray = this.billForm.get('inventoryProducts') as FormArray;
    serviceProductsArray.clear();
    inventoryProductsArray.clear();

    const allDetails = this.salesDetails.details || [];
    allDetails.forEach((item: any) => {
      const group = this.createProductFormGroup(item);
      if (item.ProductType === 'service') {
        serviceProductsArray.push(group);
      } else if (item.ProductType === 'inventory') {
        inventoryProductsArray.push(group);
      }
    });

    this.originalServiceProducts = serviceProductsArray.value.map((x: any) => ({ ...x }));
    this.originalInventoryProducts = inventoryProductsArray.value.map((x: any) => ({ ...x }));

  }

  public goToPartsAccordion() {
    const collapseOne = document.getElementById('collapseOne');
    if (collapseOne) {
      new (window as any).bootstrap.Collapse(collapseOne, { toggle: false }).hide();
    }
    const collapseThree = document.getElementById('collapseThree');
    if (collapseThree) {
      new (window as any).bootstrap.Collapse(collapseThree, { toggle: false }).hide();
    }
    const collapseTwo = document.getElementById('collapseTwo');
    if (collapseTwo) {
      new (window as any).bootstrap.Collapse(collapseTwo, { toggle: false }).show();
    }
    this.isServiceOpen = false;
    this.isPartsOpen = true;
    this.isPaymentOpen = false;
  }

  public goToServiceAccordion() {
    const collapseOne = document.getElementById('collapseOne');
    if (collapseOne) {
      new (window as any).bootstrap.Collapse(collapseOne, { toggle: false }).show();
    }
    const collapseThree = document.getElementById('collapseThree');
    if (collapseThree) {
      new (window as any).bootstrap.Collapse(collapseThree, { toggle: false }).hide();
    }
    const collapseTwo = document.getElementById('collapseTwo');
    if (collapseTwo) {
      new (window as any).bootstrap.Collapse(collapseTwo, { toggle: false }).hide();
    }
    this.isServiceOpen = true;
    this.isPartsOpen = false;
    this.isPaymentOpen = false;
  }

  public goToPaymentAccordion() {
    const collapseOne = document.getElementById('collapseOne');
    if (collapseOne) {
      new (window as any).bootstrap.Collapse(collapseOne, { toggle: false }).hide();
    }
    const collapseTwo = document.getElementById('collapseTwo');
    if (collapseTwo) {
      new (window as any).bootstrap.Collapse(collapseTwo, { toggle: false }).hide();
    }
    const collapseThree = document.getElementById('collapseThree');
    if (collapseThree) {
      new (window as any).bootstrap.Collapse(collapseThree, { toggle: false }).show();
    }

    this.isServiceOpen = false;
    this.isPartsOpen = false;
    this.isPaymentOpen = true;
  }

  public getTotalReceivedAmount(): number {
    const cash = parseFloat(this.billForm.get('cash')?.value) || 0;
    const card = parseFloat(this.billForm.get('card')?.value) || 0;
    const upi = parseFloat(this.billForm.get('upi')?.value) || 0;
    const cred = parseFloat(this.billForm.get('cred')?.value) || 0;
    return cash + card + upi + cred;
  }

  public getReceivedCash(): number {
    const cash = parseFloat(this.billForm.get('cash')?.value) || 0;
    return cash;
  }

  public getTotalReceivedWithoutCash(): number {
    const card = parseFloat(this.billForm.get('card')?.value) || 0;
    const upi = parseFloat(this.billForm.get('upi')?.value) || 0;
    const cred = parseFloat(this.billForm.get('cred')?.value) || 0;
    return card + upi + cred;
  }

  public getChangeToReturn(): number {
    let due = this.finalAmount;
    const receivedCash = parseFloat(this.billForm.get('cash')?.value) || 0;
    if (this.getTotalReceivedWithoutCash() > due) {
      this.amountWithoutCashExceedsDue = true;
      return 0;
    }
    else if (this.getTotalReceivedWithoutCash() == due && receivedCash > 0) {
      this.amountWithoutCashExceedsDue = true;
      return 0;
    }
    else {
      const actualCashToBeReceived = due - this.getTotalReceivedWithoutCash();
      this.amountWithoutCashExceedsDue = false;
      return receivedCash > actualCashToBeReceived ? receivedCash - actualCashToBeReceived : 0;
    }
  }

  public handlePayInConfirm(res: any) {
    this.showPayInModal = false;
    setTimeout(() => {
      this.getOrderDetails(this.SalesPOSOrderID);
      if (res.Result == "Success") {
        this.notify(true, 'Transaction saved successfully');
      }
    }, 500);
  }

  public handlePayInClose() {
    this.showPayInModal = false;
  }

  public openModal() {
    this.showPayInModal = true;
  }

  public submitProductEdit() {
    if (this.editingProductForm.valid && this.editingProductIndex !== -1) {
      if (this.editingProductType === 'service') {
        const group = this.serviceProductsArray.at(this.editingProductIndex) as FormGroup;
        const updatedValue = {
          ...this.editingProductForm.value,
          ProductDiscount: this.editingProductForm.value.Discount
        }
        group.patchValue(updatedValue);
      } else if (this.editingProductType === 'inventory') {
        const group = this.inventoryProductsArray.at(this.editingProductIndex) as FormGroup;
        const updatedValue = {
          ...this.editingProductForm.value,
          ProductDiscount: this.editingProductForm.value.Discount
        }
        group.patchValue(updatedValue);
      }
      this.showProductEditModal = false;
      this.editingProductIndex = -1;
    }
  }

  public showEditMRPConfirmModal(){
    this.showMRPEditWarningModal = true;
  }

  public openRefundWithReturnModal() {
    const refundAmountPaid = this.salesDetails?.header?.RefundAmount || 0;
    this.RefundForm.get('amount')?.setValidators([
      // Validators.required,
      Validators.max(this.paidAmountOnJob - refundAmountPaid)
    ]);
    this.RefundForm.get('amount').updateValueAndValidity();
    this.showRefundModal = true;
  }

  public openRefundWithoutReturnModal() {
    const refundAmountPaid = this.salesDetails?.header?.RefundAmount || 0;
    this.RefundForm.get('amount')?.setValidators([
      Validators.required,
      Validators.max(this.paidAmountOnJob - refundAmountPaid)
    ]);
    this.RefundForm.get('amount').updateValueAndValidity();
    this.showRefundWithoutReturnModal = true;
  }

  public handleRefundConfirm(paymentInfo: any) {
    const selectedProducts = this.returnProductsArray.value.filter(item => item.isSelected);

    if (selectedProducts.length > 0) {
      const returnProductsArray = selectedProducts.map(product => ({
        productId: product.ProductID,
        orderDetailID: product.orderdetailID,
        productName: product.ProductName,
        productPrice: product.FinalPrice,
        acceptedQty: product.QtyInput,
        returnStatus: 'Accepted',
        returnDescription: '',
        returnAcceptedPrice: (product.FinalPrice * product.QtyInput),
        returnedAmount: (product.FinalPrice * product.QtyInput),
      }));

      let ReturnParams = {
        discountedOnReturn: 0,
        userId: this.salesDetails?.header?.UserID,
        createdBy: 0,
        paymentModes: paymentInfo?.paymentModesString,
        totalAmount: this.RefundForm.get('amount')?.value,
        totalLoyaltyDeduction: 0,
        returns: [
          {
            returnHeader: {
              orderID: this.salesDetails?.header?.OrderID,
              orderNumber: this.salesDetails?.header?.OrderNumber,
              totalAmount: this.selectedReturnTotals.amount,
              loyaltyDeduction: 0
            },
            returnProducts: returnProductsArray,
          }
        ]
      };

      this.isApiCalling = true;
      this.subscription.add(this.thirdPartyService.returnOrderForPOS(ReturnParams).subscribe(
        (res: any) => {
          if (res?.Result === 'Success' && res?.ResponseData === 'Success') {
            this.notify(true, 'Return & refund update successful');
            this.getOrderDetails(this.SalesPOSOrderID);
          } else {
            this.notify(false, 'Return & refund update failed');
          }
          this.isApiCalling = false;
        },
        (error: any) => {
          this.isApiCalling = false;
          this.notify(false, 'Return & refund update failed');
        }
      ));

    } else {
      let refundParams = {
        orderId: this.SalesPOSOrderID,
        customerName: this.customerDetails?.FirstName,
        customerID: this.customerDetails?.ID,
        totalAmount: paymentInfo.totalReceivedAmount,
        paymentModes: paymentInfo.paymentModesString,
      }
      this.isApiCalling = true;
      this.subscription.add(this.thirdPartyService.updateRefund(refundParams).subscribe(
        (res: any) => {
          if (res?.Result === 'Success' && res?.ResponseData === 'Success') {
            this.notify(true, 'Refund update successful');
            this.getOrderDetails(this.SalesPOSOrderID);
          } else {
            this.notify(false, 'Refund update failed');
          }
          this.isApiCalling = false;
        },
        (error: any) => {
          this.isApiCalling = false;
          this.notify(false, 'Refund update failed');
        }
      ));
    }

    this.showRefundModal = false;
  }

  public handleRefundWithoutReturnConfirm(paymentInfo: any) {
    let refundParams = {
      orderId: this.SalesPOSOrderID,
      customerName: this.customerDetails?.FirstName,
      customerID: this.customerDetails?.ID,
      totalAmount: paymentInfo.totalReceivedAmount,
      paymentModes: paymentInfo.paymentModesString,
    }
    this.isApiCalling = true;
    this.subscription.add(this.thirdPartyService.updateRefund(refundParams).subscribe(
      (res: any) => {
        if (res?.Result === 'Success' && res?.ResponseData === 'Success') {
          this.notify(true, 'Refund update successful');
          this.getOrderDetails(this.SalesPOSOrderID);
          this.RefundForm.get('amount')?.setValue(null);
        } else {
          this.notify(false, 'Refund update failed');
        }
        this.isApiCalling = false;
      },
      (error: any) => {
        this.isApiCalling = false;
      }
    ));
    this.showRefundWithoutReturnModal = false;
  }

  public handleReturnWithoutRefund() {
    const selectedProducts = this.returnProductsArray.value.filter(item => item.isSelected);

    if (selectedProducts.length > 0) {
      const returnProductsArray = selectedProducts.map(product => ({
        productId: product.ProductID,
        orderDetailID: product.orderdetailID,
        productName: product.ProductName,
        productPrice: product.FinalPrice,
        acceptedQty: product.QtyInput,
        returnStatus: 'Accepted',
        returnDescription: '',
        returnAcceptedPrice: (product.FinalPrice * product.QtyInput),
        returnedAmount: (product.FinalPrice * product.QtyInput),
      }));

      let ReturnParams = {
        discountedOnReturn: 0,
        userId: this.salesDetails?.header?.UserID,
        createdBy: 0,
        paymentModes: '',
        totalAmount: 0,
        totalLoyaltyDeduction: 0,
        returns: [
          {
            returnHeader: {
              orderID: this.salesDetails?.header?.OrderID,
              orderNumber: this.salesDetails?.header?.OrderNumber,
              totalAmount: this.selectedReturnTotals.amount,
              loyaltyDeduction: 0
            },
            returnProducts: returnProductsArray,
          }
        ]
      };

      this.isApiCalling = true;
      this.subscription.add(this.thirdPartyService.returnOrderForPOS(ReturnParams).subscribe(
        (res: any) => {
          if (res?.Result === 'Success' && res?.ResponseData === 'Success') {
            this.notify(true, 'Refund with return update successful');
            this.getOrderDetails(this.SalesPOSOrderID);
          } else {
            this.notify(false, 'Refund with return update failed');
          }
          this.isApiCalling = false;
        },
        (error: any) => {
          this.isApiCalling = false;
        }
      ));
    }
    this.showRefundModal = false;
  }

  public handleRefundClose() {
    this.showRefundModal = false;
  }

  public openPaymentModesModal(from: 'checkout' | 'refund' | 'update' | 'edit-advance' | 'add-advance') {
    this.calledFrom = from;
    this.showPaymentModesModal = true;
  }

  public handlePaymentModalClose() {
    this.showPaymentModesModal = false;
  }

  public handlePaymentSaved(event: { paymentModes: any[]; totalAmount: number; changeToReturn: number; calledFrom: 'checkout' | 'refund' | 'update' | 'edit-advance' | 'add-advance'; totalCashReceived: number; }) {
    const paymentModesString = JSON.stringify(event.paymentModes);
    const change = event.changeToReturn;
    const totalReceivedAmount = event.totalAmount;
    const totalCashReceived = event.totalCashReceived;
    const paymentInfo = {
      change,
      paymentModesString,
      totalReceivedAmount,
      totalCashReceived
    }

    if (event.calledFrom == 'checkout') {
      if (this.salesDetails?.header?.OrderID) {
        this.updateOrderWithDetailsForPOS(paymentInfo);
      } else {
        this.onSubmit(paymentInfo);
      }
    } else if (event.calledFrom == 'update') {
      this.updateOrderWithDetailsForPOS(paymentInfo);
    } else if (event.calledFrom == 'edit-advance' || event.calledFrom == 'add-advance') {
      this.editAdvancedPaymentInfo = paymentInfo;
      this.showEditAdvanceModal = false;
      const newAdvance = this.editAdvancedPaymentInfo.totalReceivedAmount || 0;
      this.billForm.get('newAdvance').setValue(newAdvance);
      this.isPayAndConfirmDisabled = true;
    } else if (event.calledFrom == 'refund') {
      this.handleRefundWithoutReturnConfirm(paymentInfo);
    } else if (event.calledFrom == 'return') {
      this.handleRefundConfirm(paymentInfo);
    }
  }

  private notify(status: boolean, msg: string) {
    this.showToast = true;
    this.isSuccess = status;
    this.notificationMsg = msg;
    setTimeout(() => {
      this.showToast = false;
    }, 2000);
  }

  public getProductDiffs() {
    // Helper to compare by unique key (ID or ProductID)
    const getKey = (item: any) => item.ID || item.ProductID;

    const currentService = (this.billForm.get('serviceProducts') as FormArray).value;
    const currentInventory = (this.billForm.get('inventoryProducts') as FormArray).value;

    const diff = (original: any[], current: any[]) => {
      const added: any[] = [];
      const modified: any[] = [];
      const deleted: any[] = [];

      const originalMap = new Map(original.map(item => [getKey(item), item]));
      const currentMap = new Map(current.map(item => [getKey(item), item]));

      for (const item of current) {
        const key = getKey(item);
        if (!originalMap.has(key)) {
          added.push(item);
        } else {
          const orig = originalMap.get(key);
          if (JSON.stringify(orig) !== JSON.stringify(item)) {
            modified.push(item);
          }
        }
      }

      for (const item of original) {
        const key = getKey(item);
        if (!currentMap.has(key)) {
          deleted.push(item);
        }
      }

      return { added, modified, deleted };
    };

    const serviceDiff = diff(this.originalServiceProducts, currentService);
    const inventoryDiff = diff(this.originalInventoryProducts, currentInventory);

    return {
      service: serviceDiff,
      inventory: inventoryDiff
    };
  }

  public haveProductsChanged(): boolean {
    const diffs = this.getProductDiffs();
    const serviceChanged = diffs.service.added.length > 0 ||
      diffs.service.modified.length > 0 ||
      diffs.service.deleted.length > 0;
    const inventoryChanged = diffs.inventory.added.length > 0 ||
      diffs.inventory.modified.length > 0 ||
      diffs.inventory.deleted.length > 0;
    return serviceChanged || inventoryChanged;
  }

  public async saveSelectedProducts() {
    const diffs = this.getProductDiffs();
    let addedDetails = [];
    let deletedDetails = [];
    let modifiedDetails = [];

    const allAddedproducts = [...diffs.service.added, ...diffs.inventory.added];
    const allDeletedproducts = [...diffs.service.deleted, ...diffs.inventory.deleted];
    const allModifiedproducts = [...diffs.service.modified, ...diffs.inventory.modified];

    const serviceProducts = this.billForm.get('serviceProducts')!.value || [];
    const inventoryProducts = this.billForm.get('inventoryProducts')!.value || [];
    this.allSelectedProducts = [...serviceProducts, ...inventoryProducts];
    const selectedPartsArray = [...inventoryProducts]
    const latest = this.jobDetails[0];

    const allOriginalProducts = [...this.serviceProducts, ...this.inventoryProducts];
    let productUpdateArray = this.allSelectedProducts.filter(item1 => {
      const match = allOriginalProducts.find(item2 => this.getProductID(item2) === this.getProductID(item1));
      return match && match.MRP !== item1.MRP;
    });

    productUpdateArray = productUpdateArray.map((item: any) => ({
      productID: this.getProductID(item),
      mrp: item.MRP
    }))

    if (this.allSelectedProducts.length > 0) {
      if (this.SalesPOSOrderID) {
        const quickProducts = allAddedproducts.filter(p => !p.ID);
        if (quickProducts.length > 0) {
          this.doHaveQuickProducts = true;
        }
        for (const product of quickProducts) {
          product.ID = await this.getQuickProductID(product);
        }

        const hasInvalidID = allAddedproducts.some(
          p => p.ID === 0 || p.ID === null
        );

        if (hasInvalidID) {
          this.notify(false, 'Please remove last created products');
          return;
        }
      } else {
        const quickProducts = this.allSelectedProducts.filter(p => !p.ID);
        if (quickProducts.length > 0) {
          this.doHaveQuickProducts = true;
        }
        for (const product of quickProducts) {
          product.ID = await this.getQuickProductID(product);
        }
        const hasInvalidID = this.allSelectedProducts.some(
          p => p.ID === 0 || p.ID === null
        );

        if (hasInvalidID) {
          this.notify(false, 'Please remove last created products');
          return;
        }
      }
    }

    if (allAddedproducts.length > 0) {
      addedDetails = allAddedproducts.map(product => ({
        productID: product.productID || product.ID || product.ProductID,
        price: product.FinalPrice,
        quantity: product.QtyInput,
        mrp: product.MRP,
        totalPrice: Number(product.TotalPrice) || 0,
        purchasePrice: product.PurchasePrice || product.PurchaseValue || 0,
      }));
    }

    if (allDeletedproducts.length > 0) {
      deletedDetails = allDeletedproducts.map(product => ({
        detailId: product.orderdetailID || 0,
        productID: product.ProductID || product.productID || product.ID,
        price: product.FinalPrice,
        quantity: product.QtyInput,
        mrp: product.MRP,
        totalPrice: Number(product.TotalPrice) || 0,
        purchasePrice: product.PurchasePrice || product.PurchaseValue || 0,
      }));
    }

    if (allModifiedproducts.length > 0) {
      modifiedDetails = allModifiedproducts.map(product => ({
        detailId: product.orderdetailID || 0,
        productID: product.ProductID || product.productID || product.ID,
        price: product.FinalPrice,
        quantity: product.QtyInput,
        mrp: product.MRP,
        totalPrice: Number(product.TotalPrice) || 0,
        purchasePrice: product.PurchasePrice || product.PurchaseValue || 0,
      }));
    }

    const orderDetailsArray = this.allSelectedProducts.map(product => ({
      userID: latest.SalesPOSUserID || 0,
      productID: product.ID,
      price: product.FinalPrice,
      quantity: product.QtyInput,
      createdBy: latest.SalesPOSUserID || 0,
      organisationID: 0,
      unknownUserKey: ''
    }));
    const serviceDiscount = this.billForm.get('serviceDiscount')?.value || 0;
    const partsDiscount = this.billForm.get('partsDiscount')?.value || 0;
    const customDiscount = this.billForm.get('customDiscount')?.value || 0;
    const discountData = { serviceDiscount, partsDiscount, customDiscount };
    const totalDiscount = this.totalDiscount;
    let discountString = '';
    if (discountData) {
        discountString = JSON.stringify(discountData);
    }
    let sendingData = {
      orderHeader: {
        id: this.SalesPOSOrderID,
        totalDeliveryCharge: 0,
        grandTotalAmount: 0,
        productTotalAmount: 0,
        CustomerName: latest.ContactPerson,
        CustomerPhone: latest.ContactNo,
        DeliveryAddress: '',
        DeliveryPlace: '',
        DeliveryLandMark: '',
        DeliveryPincode: '',
        orderStatus: 'Placed',
        pickFromDeliveryPlace: false,
        ItemsCount: serviceProducts.length + inventoryProducts.length,
        paymentType: 'COD',
        discountBreakdown: discountString,
        appliedDiscount: totalDiscount,
        updateThirdPartyOrder: true,
        serviceCost: this.getTotalServiceMRP(),
        partsQty: selectedPartsArray.length,
        partsCost: this.getTotalInventoryMRP(),
        branchId: String(this.branchID),
        workId: this.workId,
        userID: latest.SalesPOSUserID || 0,
        changeToReturned: 0,
        totalReceivedAmount: 0,
        paymentModes: '',
        advanceAmount: this.salesDetails?.header?.AdvanceAmount || 0,
        cartUniqueKey: this.salesDetails?.details[0]?.CartUniqueKey || '',
        saleType: 'service'
      },
      addedDetails: addedDetails,
      modifiedDetails: modifiedDetails,
      deletedDetails: deletedDetails,
      orderDetails: orderDetailsArray,
      productUpdateDetails: productUpdateArray,
    }

    if (this.editAdvancedPaymentInfo) {
      const advancePay = JSON.parse(this.editAdvancedPaymentInfo?.paymentModesString);
      sendingData.orderHeader.paymentModes = this.editAdvancedPaymentInfo?.paymentModesString;
      sendingData.orderHeader.advanceAmount = this.editAdvancedPaymentInfo.totalReceivedAmount;

      if (!this.isAdvanceEdited) {
        sendingData.orderHeader.paymentModes = '';
      }
    }
    
    if (this.SalesPOSOrderID) {
      this.isApiCalling = true;
      this.subscription.add(this.thirdPartyService.UpdateOrderWithDetailsForPOS(sendingData).subscribe((res: any) => {
          if (res?.Result === 'Success' && res?.ResponseData === "Success") {
            this.getServiceInfo();
            if (this.doHaveQuickProducts) {
              this.getInventoryProducts();
              this.getServices();
              this.doHaveQuickProducts = false;
            }
            this.isPayAndConfirmDisabled = false;
          }
          this.isApiCalling = false;
          this.notify(true, 'Saved successfully');
        },
        (error: any) => {
          this.isLoading = false;
          this.isApiCalling = false;
        }
      ));
    } else {
      this.isApiCalling = true;
      this.subscription.add(this.thirdPartyService.CheckOutOrderForPOS(sendingData).subscribe(
        (res: any) => {
          if (res?.Result === 'Success' && res?.ResponseData.OrderNumber) {
            this.SalesPOSOrderID = res?.ResponseData?.OrderID;
            this.notify(true, 'Saved successfully');
            this.updateSalesPOSOrderID(this.workId, this.SalesPOSOrderID);
            this.getServiceInfo();
            this.getOrderDetails(this.SalesPOSOrderID);
            if (this.doHaveQuickProducts) {
              this.getInventoryProducts();
              this.getServices();
              this.doHaveQuickProducts = false;
            }
          }  else if(res?.Result === 'Success' && res?.ResponseData == "No Stock"){
            this.notify(false, 'Some of the products are out of stock. Please check and try again');
          }
          this.isApiCalling = false;
        },
        (error: any) => {
          this.isApiCalling = false;
        }
      ));
    }

  }

  public restoreOriginalDetails() {
    if (this.salesDetails) {
      this.patchBillSummary();
    } else {
      const serviceProductsArray = this.billForm.get('serviceProducts') as FormArray;
      const inventoryProductsArray = this.billForm.get('inventoryProducts') as FormArray;
      serviceProductsArray.clear();
      inventoryProductsArray.clear();
      if (serviceProductsArray.length == 0) {
        const firstProduct = this.serviceProducts[0];
        const group = this.fb.group({
          ID: [firstProduct.ID],
          ProductName: [firstProduct.ProductName],
          MRP: [firstProduct.MRP],
          QtyInput: [firstProduct.QtyInput || 1, [Validators.required, Validators.min(1)]],
          Discount: [((firstProduct.MRP - firstProduct.FinalPrice) / firstProduct.MRP) * 100 || 0],
          FinalPrice: [firstProduct.FinalPrice],
          Image: [firstProduct.Image],
          TotalPrice: [firstProduct.FinalPrice * (firstProduct.QtyInput || 1)]
        });
        serviceProductsArray.push(group);
      }
    }
    if (this.isPaidJob) {
      this.isCostAndPayDisabled = true;
    }
  }

  public showOrderAgainstTransactionList() {
    if (!this.orderTransactions.displayOrderTransactionList) {
      this.orderTransactions.displayOrderTransactionList = true;
      this.getOrderAgainstTransactionList();
    } else {
      this.orderTransactions.displayOrderTransactionList = false;
    }
  }

  public getOrderAgainstTransactionList() {
    this.orderTransactions.isTransactionLoading = true;
    this.transactionGetParams.orderID = this.salesDetails?.header?.OrderID;
    this.subscription.add(this.thirdPartyService.GetAllTransactionsFromAccountsBySeller(this.transactionGetParams).subscribe(
      (res: any) => {
        if (res && res?.Result == 'Success' && res?.ResponseData) {
          this.orderTransactions.transactionsList = res.ResponseData;
          this.orderTransactions.isTransactionLoading = false;
        } else {
          this.orderTransactions.isTransactionLoading = false;
        }
      },
      (err: HttpErrorResponse) => {
        this.orderTransactions.isTransactionLoading = false;
        this.configService.notify({
          severity: 'error',
          summary: 'Failed',
          detail: `Something went wrong! try later.`,
        });
      }
    ));
  }

  public openQuickAddProductForm(type: 'service' | 'inventory') {
    this.quickAddProductType = type;
    this.showQuickAddProductForm = true;
    this.showMoreFields = false;
    this.quickAddProductForm.reset();  
    this.clearAllPriceDiscountValues();  
    this.finalPriceIsMaster = false;  
    this.quickAddProductForm.get('ProductType')?.setValue(type);
    this.quickAddProductForm.get('QtyInput')?.setValue(1);
  }

  public onCloseQuickProductAddForm(){
    this.showQuickAddProductForm = false;
    this.quickAddProductForm.reset();
    this.finalPriceIsMaster = false;
    this.showMoreFields = false;
 }

  public saveQuickAddProduct() {
    if (this.quickAddProductForm.valid) {
      const product = this.quickAddProductForm.value;
      if (product.ProductType === 'service') {
        this.addToServiceList(product, -1, true);
      } else {
        this.addToPartsList(product, -1, true);
      }
      this.showQuickAddProductForm = false;
    } else {
      this.quickAddProductForm.markAllAsTouched();
    }
  }

  public cancelQuickAddProduct() {
    this.showQuickAddProductForm = false;
    this.onCloseQuickProductAddForm();
  }

  public toggleMoreFields() {
    this.showMoreFields = !this.showMoreFields;
  }

private addQuickProductFormListeners() {

this.subscription.add(this.quickAddProductForm.get('FinalPrice')?.valueChanges.pipe(
  debounceTime(600),
  distinctUntilChanged()
).subscribe(v => {

  const final = Number(v);
  const mrp = Number(this.quickAddProductForm.get('MRP')?.value);
  const unit = Number(this.quickAddProductForm.get('UnitPrice')?.value);

  if (final && final > 0) {
    if (!this.finalPriceIsMaster) {
      this.finalPriceIsMaster = true;
      this.quickAddProductForm.get('UnitPrice')?.setValue(final, { emitEvent: false });
      this.quickAddProductForm.get('MRP')?.setValue(final, { emitEvent: false });

      const productType = this.quickAddProductForm.get('ProductType')?.value;
      if (productType === 'service') {
        this.quickAddProductForm.get('PurchasePrice')?.setValue(0, { emitEvent: false });
      } else {
        this.quickAddProductForm.get('PurchasePrice')?.setValue(final, { emitEvent: false });
      }
    } else if(mrp > 0 && mrp < final && unit > 0 && unit < final){
      this.quickAddProductForm.get('FinalPrice')?.setValue(v, { emitEvent: false });
      this.quickAddProductForm.get('UnitPrice')?.setErrors(v, { emitEvent: false });
    }
    
   
    this.quickAddProductForm.get('Discount')?.setValue(null, { emitEvent: false });
    this.quickAddProductForm.get('DiscountPercent')?.setValue(null, { emitEvent: false });
    this.quickAddProductForm.get('mrpDiscount')?.setValue(null, { emitEvent: false });
    this.quickAddProductForm.get('mrpDiscountPercent')?.setValue(null, { emitEvent: false });

    
    this.calculateDiscountOnChanges(
      this.quickAddProductForm.get('UnitPrice')?.value,
      this.quickAddProductForm.get('FinalPrice')?.value
    );
    this.calculateMRPDiscountOnChanges(
      this.quickAddProductForm.get('MRP')?.value,
      this.quickAddProductForm.get('FinalPrice')?.value
    );
  } else {
    this.finalPriceIsMaster = false;
    this.clearAllPriceDiscountValues();
  }
}));


this.subscription.add(this.quickAddProductForm.get('MRP')?.valueChanges
  .pipe(
    debounceTime(300),
    distinctUntilChanged()
  )
  .subscribe(mrpValue => {
    const mrp = Number(mrpValue);
    const unit = Number(this.quickAddProductForm.get('UnitPrice')?.value);
    const final = Number(this.quickAddProductForm.get('FinalPrice')?.value);

    if(this.finalPriceIsMaster && final < mrp){ 
    this.removeFormControlError('FinalPrice', 'finalGreaterThanMRP'); 
    this.removeFormControlError('UnitPrice', 'unitGreaterThanMRP'); 
    this.quickAddProductForm.get('Discount')?.setValue(null, { emitEvent: false });
    this.quickAddProductForm.get('DiscountPercent')?.setValue(null, { emitEvent: false });
    this.quickAddProductForm.get('mrpDiscount')?.setValue(null, { emitEvent: false });
    this.quickAddProductForm.get('mrpDiscountPercent')?.setValue(null, { emitEvent: false });

    // Recalculate discounts
    this.calculateDiscountOnChanges(
      this.quickAddProductForm.get('UnitPrice')?.value,
      this.quickAddProductForm.get('FinalPrice')?.value
    );
    this.calculateMRPDiscountOnChanges(
      this.quickAddProductForm.get('MRP')?.value,
      this.quickAddProductForm.get('FinalPrice')?.value
    );
      return;
    }


    if (!this.finalPriceIsMaster && mrp === 0) {
      this.quickAddProductForm.get('UnitPrice')?.setValue(0, { emitEvent: false });
      this.quickAddProductForm.get('FinalPrice')?.setValue(0, { emitEvent: false });
      this.clearAllPriceDiscountValues();
      return;
    }

    if (this.finalPriceIsMaster) {

      if (final > mrp) {
        this.quickAddProductForm.get('FinalPrice')?.setErrors({ finalGreaterThanMRP: true });
      } else {
        this.quickAddProductForm.get('FinalPrice')?.setErrors(null);
      }

      if (unit > mrp) {
        this.quickAddProductForm.get('UnitPrice')?.setErrors({ unitGreaterThanMRP: true });
      } else {
        this.quickAddProductForm.get('UnitPrice')?.setErrors(null);
      }

      return;
    }

    if (!unit || unit === 0) {
      this.quickAddProductForm.get('UnitPrice')?.setValue(mrp, { emitEvent: false });
    }

    this.quickAddProductForm.get('FinalPrice')?.setValue(mrp, { emitEvent: false });

    this.calculateDiscountOnChanges(
      this.quickAddProductForm.get('UnitPrice')?.value,
      this.quickAddProductForm.get('FinalPrice')?.value
    );

    this.calculateMRPDiscountOnChanges(
      mrp,
      this.quickAddProductForm.get('FinalPrice')?.value
    );
  }));


 this.subscription.add(this.quickAddProductForm.get('UnitPrice')?.valueChanges
  .pipe(
    debounceTime(300),
    distinctUntilChanged()
  )
  .subscribe(unitValue => {
    const unit = Number(unitValue);
    const mrp = Number(this.quickAddProductForm.get('MRP')?.value);
    const final = Number(this.quickAddProductForm.get('FinalPrice')?.value);

    if(this.finalPriceIsMaster && final < unit){ 
      this.removeFormControlError('FinalPrice', 'finalGreaterThanUnitPrice'); 
      this.removeFormControlError('UnitPrice', 'unitGreaterThanMRP');
    }

      if(unit == 0 && final > 0 && this.finalPriceIsMaster ){
      this.quickAddProductForm.get('Discount')?.setValue(null, { emitEvent: false });
      this.quickAddProductForm.get('DiscountPercent')?.setValue(null, { emitEvent: false });
      this.quickAddProductForm.get('mrpDiscount')?.setValue(null, { emitEvent: false });
      this.quickAddProductForm.get('mrpDiscountPercent')?.setValue(null, { emitEvent: false });

      this.calculateDiscountOnChanges(
      this.quickAddProductForm.get('UnitPrice')?.value,
      this.quickAddProductForm.get('FinalPrice')?.value
    );

    this.calculateMRPDiscountOnChanges(
      this.quickAddProductForm.get('MRP')?.value,
      this.quickAddProductForm.get('FinalPrice')?.value
    );
      }

    if (final > unit && final > 0) {
       this.quickAddProductForm.get('FinalPrice')?.setErrors({ finalGreaterThanUnitPrice: true });
       this.clearAllPriceDiscountValues();
       return;
    } else {
      this.removeFormControlError('FinalPrice', 'finalGreaterThanUnitPrice');
    }


    if (unit > mrp && mrp > 0) {
      this.quickAddProductForm.get('UnitPrice')?.setErrors({ unitGreaterThanMRP: true });
      this.clearAllPriceDiscountValues();
    } else {
      this.removeFormControlError('UnitPrice', 'unitGreaterThanMRP');
    }

    if (this.finalPriceIsMaster) {
      if (final > mrp) {
        this.quickAddProductForm.get('FinalPrice')?.setErrors({ finalGreaterThanMRP: true });
      } else {
        this.removeFormControlError('FinalPrice', 'finalGreaterThanMRP');
      }
      this.quickAddProductForm.get('Discount')?.setValue(null, { emitEvent: false });
      this.quickAddProductForm.get('DiscountPercent')?.setValue(null, { emitEvent: false });
      this.quickAddProductForm.get('mrpDiscount')?.setValue(null, { emitEvent: false });
      this.quickAddProductForm.get('mrpDiscountPercent')?.setValue(null, { emitEvent: false });

      this.calculateDiscountOnChanges(
      this.quickAddProductForm.get('UnitPrice')?.value,
      this.quickAddProductForm.get('FinalPrice')?.value
    );

    this.calculateMRPDiscountOnChanges(
      this.quickAddProductForm.get('MRP')?.value,
      this.quickAddProductForm.get('FinalPrice')?.value
    );
      return;
    }

    if (!unit || unit === 0) {
      if (mrp > 0) {
        this.quickAddProductForm.get('UnitPrice')?.setValue(mrp, { emitEvent: false });
        this.quickAddProductForm.get('FinalPrice')?.setValue(mrp, { emitEvent: false });
      } else {
        // Everything is zero → reset
        this.quickAddProductForm.get('UnitPrice')?.setValue(0, { emitEvent: false });
        this.quickAddProductForm.get('FinalPrice')?.setValue(0, { emitEvent: false });
        this.clearAllPriceDiscountValues();
        return;
      }
    } else {

      this.quickAddProductForm.get('FinalPrice')?.setValue(unit, { emitEvent: false });
    }

    this.quickAddProductForm.get('Discount')?.setValue(null, { emitEvent: false });
    this.quickAddProductForm.get('DiscountPercent')?.setValue(null, { emitEvent: false });

    this.calculateDiscountOnChanges(
      this.quickAddProductForm.get('UnitPrice')?.value,
      this.quickAddProductForm.get('FinalPrice')?.value
    );

    this.calculateMRPDiscountOnChanges(
      this.quickAddProductForm.get('MRP')?.value,
      this.quickAddProductForm.get('FinalPrice')?.value
    );
  }));

  this.subscription.add(this.quickAddProductForm.get('DiscountPercent')?.valueChanges.pipe(
    debounceTime(300),
    distinctUntilChanged()
  ).subscribe(v => {
    if (v && v > 0) {

      const disAmount = this.getDiscountAmountFromPerc(
        v,
        this.quickAddProductForm.get('UnitPrice')?.value
      );

      const unit = Number(this.quickAddProductForm.get('UnitPrice')?.value);
      const mrp = Number(this.quickAddProductForm.get('MRP')?.value);

      if (disAmount > unit || disAmount > mrp) {
        this.quickAddProductForm.get('Discount')?.setValue(null, { emitEvent: false });
        this.quickAddProductForm.get('DiscountPercent')?.setValue(null, { emitEvent: false });
        this.quickAddProductForm.get('FinalPrice')?.setValue(unit, { emitEvent: false });
      } else {

        this.finalPriceIsMaster = false;  

        this.quickAddProductForm.get('Discount')?.setValue(disAmount, { emitEvent: false });
        this.quickAddProductForm.get('FinalPrice')?.setValue(unit - disAmount, { emitEvent: false });
      }

    } else {

      const unit = Number(this.quickAddProductForm.get('UnitPrice')?.value);
      this.quickAddProductForm.get('Discount')?.setValue(null, { emitEvent: false });
      this.quickAddProductForm.get('DiscountPercent')?.setValue(null, { emitEvent: false });
      this.quickAddProductForm.get('FinalPrice')?.setValue(unit, { emitEvent: false });
    }
  }));

  this.subscription.add(this.quickAddProductForm.get('Discount')?.valueChanges.pipe(
    debounceTime(300),
    distinctUntilChanged()
  ).subscribe(v => {

    const unit = Number(this.quickAddProductForm.get('UnitPrice')?.value);
    const mrp = Number(this.quickAddProductForm.get('MRP')?.value);

    if (v && v > 0) {

      if (Number(v) > unit || Number(v) > mrp) {
        this.quickAddProductForm.get('Discount')?.setValue(null, { emitEvent: false });
        this.quickAddProductForm.get('DiscountPercent')?.setValue(null, { emitEvent: false });
        this.quickAddProductForm.get('FinalPrice')?.setValue(unit, { emitEvent: false });
      } else {

        this.finalPriceIsMaster = false;

        this.quickAddProductForm.get('DiscountPercent')?.setValue(
          this.getDiscountPrecFromAmount(v, unit),
          { emitEvent: false }
        );

        this.quickAddProductForm.get('FinalPrice')?.setValue(unit - Number(v), { emitEvent: false });
      }

    } else {
      this.quickAddProductForm.get('Discount')?.setValue(null, { emitEvent: false });
      this.quickAddProductForm.get('DiscountPercent')?.setValue(null, { emitEvent: false });
      this.quickAddProductForm.get('FinalPrice')?.setValue(unit, { emitEvent: false });
    }
  }));

}


  private clearAllPriceDiscountValues() {
    this.quickAddProductForm.get('DiscountPercent')?.setValue(null, { emitEvent: false });
    this.quickAddProductForm.get('Discount')?.setValue(null, { emitEvent: false });
    this.quickAddProductForm.get('mrpDiscountPercent')?.setValue(null, { emitEvent: false });
    this.quickAddProductForm.get('mrpDiscount')?.setValue(null, { emitEvent: false });
    this.quickAddProductForm.get('UnitPrice')?.setValue(null, { emitEvent: false });
    this.quickAddProductForm.get('FinalPrice')?.setValue(null, { emitEvent: false });
  }

  private calculateMRPDiscountOnChanges(mrp: number, finalPrice: number) {
    let mrpVal = this.quickAddProductForm.get('MRP')?.value;
    let finalPriceVal = this.quickAddProductForm.get('FinalPrice')?.value;
    
    if (mrpVal <= 0 || finalPriceVal <= 0 || isNaN(mrpVal) || isNaN(finalPriceVal)){
    this.quickAddProductForm.get('mrpDiscount')?.setValue(null, { emitEvent: false });
    this.quickAddProductForm.get('mrpDiscountPercent')?.setValue(null, { emitEvent: false });
    return;
  }

  if (this.finalPriceIsMaster) {
    const discountAmount = mrp - Number(finalPrice);
    const discountPercentage = Math.round((discountAmount / mrp) * 100);

    this.quickAddProductForm.get('mrpDiscount')?.setValue(discountAmount, { emitEvent: false });
    this.quickAddProductForm.get('mrpDiscountPercent')?.setValue(discountPercentage, { emitEvent: false });
    return;
  }

  if (finalPrice && finalPrice > 0 && mrp && mrp > 0) {

    if (Number(finalPrice) > mrp) {
      this.quickAddProductForm.get('mrpDiscount')?.setValue(null, { emitEvent: false });
      this.quickAddProductForm.get('mrpDiscountPercent')?.setValue(null, { emitEvent: false });
      this.quickAddProductForm.get('FinalPrice')?.setValue(mrp, { emitEvent: false });
    } else {
      const discountAmount = mrp - Number(finalPrice);
      const discountPercentage = Math.round((discountAmount / mrp) * 100);

      this.quickAddProductForm.get('mrpDiscount')?.setValue(discountAmount, { emitEvent: false });
      this.quickAddProductForm.get('mrpDiscountPercent')?.setValue(discountPercentage, { emitEvent: false });
    }
  }
}


private calculateDiscountOnChanges(unitPrice: number, finalPrice: number) {
  let unitPriceVal = this.quickAddProductForm.get('UnitPrice')?.value;
  let finalPriceVal = this.quickAddProductForm.get('FinalPrice')?.value;
  if(unitPriceVal <= 0 || finalPriceVal <= 0 || isNaN(unitPriceVal) || isNaN(finalPriceVal)){
    this.quickAddProductForm.get('Discount')?.setValue(null, { emitEvent: false });
    this.quickAddProductForm.get('DiscountPercent')?.setValue(null, { emitEvent: false });
    return;
  }

  if (this.finalPriceIsMaster) {
    const discountAmount = unitPrice - Number(finalPrice);
    const discountPercentage = Math.round((discountAmount / unitPrice) * 100);

    this.quickAddProductForm.get('Discount')?.setValue(discountAmount, { emitEvent: false });
    this.quickAddProductForm.get('DiscountPercent')?.setValue(discountPercentage, { emitEvent: false });
    return;
  }

  if (finalPrice && finalPrice > 0 && unitPrice && unitPrice > 0) {
    if (Number(finalPrice) > unitPrice) {
      this.quickAddProductForm.get('Discount')?.setValue(null, { emitEvent: false });
      this.quickAddProductForm.get('DiscountPercent')?.setValue(null, { emitEvent: false });
      this.quickAddProductForm.get('FinalPrice')?.setValue(unitPrice, { emitEvent: false });
    } else {
      const discountAmount = unitPrice - Number(finalPrice);
      const discountPercentage = Math.round((discountAmount / unitPrice) * 100);

      this.quickAddProductForm.get('Discount')?.setValue(discountAmount, { emitEvent: false });
      this.quickAddProductForm.get('DiscountPercent')?.setValue(discountPercentage, { emitEvent: false });
    }
  }
}


  private getDiscountAmountFromPerc(precent: string, unitPrice: number): number {
    return Math.round(unitPrice * (Number(precent) / 100));
  }

  private getDiscountPrecFromAmount(amount: string, unitPrice: number): number {
    return Math.round((Number(amount) / unitPrice) * 100);
  }
  public getQuickProductID(product: any): Promise<number> {
    return new Promise((resolve, reject) => {
      const sendingData = {
        unitPrice: product.UnitPrice,
        name: product.ProductName,
        mrp: product.MRP,
        productType: product.ProductType,
        discount: product.ProductDiscount,
        purchasePrice: product.PurchasePrice,
        mrpDiscount: product.MRPDiscount || 0,
      };
      this.isApiCalling = true;
      this.subscription.add(this.thirdPartyService.addProduct(sendingData).subscribe(
        (res: any) => {
          this.isApiCalling = false;
          if (res?.Result === 'Success' && res?.ResponseData) {
            const id = Number(res.ResponseData);
            resolve(isNaN(id) ? 0 : id);
          } else {
            resolve(0);
          }
        },
        (error: any) => {
          this.isApiCalling = false;
          resolve(0);
        }
      ));
    });
  }

  increaseQuickProductQty() {
    const control = this.quickAddProductForm.get('QtyInput');
    if (control) {
      const current = control.value || 0;
      control.setValue(current + 1);
    }
  }

  decreaseQuickProductQty() {
    const control = this.quickAddProductForm.get('QtyInput');
    if (control) {
      const current = control.value || 0;
      if (current > 1) {
        control.setValue(current - 1);
      }
    }
  }

  increaseReturnQty(index: number) {
    const control = this.returnProductsArray.at(index).get('QtyInput');
    control?.setValue((control.value || 0) + 1);
  }

  decreaseReturnQty(index: number) {
    const control = this.returnProductsArray.at(index).get('QtyInput');
    if (control && control.value > 1) {
      control.setValue(control.value - 1);
    }
  }

  private calculateReturnTotals() {
    const selectedGroups = this.returnProductsArray.controls.filter(
      group => group.get('isSelected')?.value
    );

    this.selectedReturnTotals = selectedGroups.reduce((totals, group) => {
      const qty = Number(group.get('QtyInput')?.value) || 0;
      const price = Number(group.get('FinalPrice')?.value) || 0;

      return {
        quantity: totals.quantity + qty,
        amount: totals.amount + (qty * price)
      };
    }, { quantity: 0, amount: 0 });

    const refundAmountPaid = this.salesDetails?.header?.RefundAmount || 0;
    const refundableAmount = this.paidAmountOnJob - refundAmountPaid;

    if (this.selectedReturnTotals.amount <= refundableAmount) {
      this.RefundForm.get('amount')?.setValue(this.selectedReturnTotals.amount);
    } else {
      this.RefundForm.get('amount')?.setValue(null);
    }

  }

  public resetReturnProducts() {
    this.returnProductsArray.clear();
    this.getReturnableProductsQuantityByOrder();
  }

  public getUnixFormatedTime(unixTimestamp: number): string {
    return moment.unix(unixTimestamp).format("DD MMM YY, hh:mm a");
  }

  public closeTransactionList() {
    this.orderTransactions.displayOrderTransactionList = false
    if (this.salesDetails?.header?.OrderStatus === 'Delivered') {
      setTimeout(() => {
        this.goToPaymentAccordion();
      }, 1000);
    }
  }

  public getReturnableProductsQuantityByOrder() {
    const params = { orderID: this.salesDetails?.header?.OrderID };
    this.subscription.add(this.thirdPartyService.getReturnableProductsQuantityByOrder(params).subscribe(
      (res: any) => {
        if (res && res?.Result == 'Success' && res?.ResponseData) {
          const allProducts = res?.ResponseData?.details || [];
          allProducts.forEach((item: any) => {
            if (item.ProductType === 'inventory') {
              const returnGroup = this.createReturnProductFormGroup(item);
              if (item.ReturnStatus === 'Returned') {
                this.returnProductsArray.push(returnGroup);
              } else {
                this.returnProductsArray.insert(0, returnGroup);
              }
            }
          })
        }
      },
      (err: HttpErrorResponse) => {
      }
    ));
  }

  callNumber(number: string) {
    if (number) {
      window.location.href = `tel:${number}`;
    } else {
      this.notify(false, 'No phone number provided');
    }
  }

  public serviceWarningModal(callFrom: 'checkout' | 'update') {
    this.continueTo = callFrom;
    this.showServiceWarningModal = true;
  }

  public handleServiceWarningContinue() {
    if (this.continueTo === 'checkout') {
      this.openPaymentModesModal('checkout')
    } else if (this.continueTo === 'update') {
      this.openPaymentModesModal('update');
    }
    this.showServiceWarningModal = false;
  }

  public onAddServicesClick() {
    setTimeout(() => {
      this.goToServiceAccordion();
    }, 1000);
    this.showServiceWarningModal = false;
  }

  public focusFinalAmountInput() {
    this.finalAmountInput.nativeElement.focus();
  }

  public validatePartsDiscount(event: any) {
    const max = +this.getTotalInventoryMRP();
    let value = Number(event.target.value);

    if (value > max) {
      event.target.value = max; 
      this.billForm.get('partsDiscount')?.setValue(max);
    }

    if (value < 0) {
      event.target.value = 0; 
      this.billForm.get('partsDiscount')?.setValue(0);
    }
  }

  public validateServiceDiscount(event: any) {
    const max = +this.getTotalServiceMRP();
    let value = Number(event.target.value);

    if (value > max) {
      event.target.value = max; 
      this.billForm.get('serviceDiscount')?.setValue(max);
    }

    if (value < 0) {
      event.target.value = 0; 
      this.billForm.get('serviceDiscount')?.setValue(0);
    }
  }

  public validateAdditionalDiscount(event: any) {
    const max = this.finalAmountWithoutAdditionalDisc;
    let value = Number(event.target.value);

    if (value > max) {
      event.target.value = max; 
      this.billForm.get('customDiscount')?.setValue(max);
    }

    if (value < 0) {
      event.target.value = 0; 
      this.billForm.get('customDiscount')?.setValue(0);
    }
  }


  private loadFromStorage() {
    const deviceTypes = localStorage.getItem('deviceTypes');
    const modelNames = localStorage.getItem('modelNames');
    const phoneNames = localStorage.getItem('phoneNames');

    if (deviceTypes) this.deviceTypes = JSON.parse(deviceTypes);
    if (modelNames) this.modelNames = JSON.parse(modelNames);
    if (phoneNames) this.phoneNames = JSON.parse(phoneNames);
  }

  private removeFormControlError(controlName: string, errorKey: string) {
  let control = this.quickAddProductForm.get(controlName);
  if (!control) return;
  const errors = control.errors;
  if (errors && errors[errorKey]) {
    delete errors[errorKey];
    if (Object.keys(errors).length === 0) {
      control.setErrors(null);
    } else {
      control.setErrors(errors);
    }
  }
}

public getCurrentOrderStatus(): OrderStatus {

    if (this.salesDetails?.header?.OrderStatus === 'Placed') {
      return OrderStatus.Saved;
    } else if (this.salesDetails?.header?.OrderStatus === 'Delivered') {
      if (this.salesDetails?.header?.PaymentModesValue) {
        const paymentModesValue = JSON.parse(
          this.salesDetails?.header?.PaymentModesValue
        );
        const creditBalance = paymentModesValue?.Credit;
        if(creditBalance > 0){
          return OrderStatus.Partial;
        }else{
          return OrderStatus.Paid;
        }
      }
    }

    return OrderStatus.Saved;
  }

  getStatusClass() {
    switch (this.currentOrderStatus) {
      case OrderStatus.Saved:
        return 'status-saved';
      case OrderStatus.Paid:
        return 'status-paid';
      case OrderStatus.Partial:
        return 'status-partial';
      case OrderStatus.UnsavedChanges:
        return 'status-unsaved';
      default:
        return '';
    }
  }

  public copyContactNumber() {
    const number = this.serviceNearDetailForm
      .get('jobDetailFormGroup.ContactNo')
      ?.value;

    if (!number) return;

    navigator.clipboard.writeText(number).then(() => {
      this.notify(true, 'Contact number copied to clipboard');
    });
  }

  public createAndPatchAccessoriesForm(accessories: any) {
    const jobDetailAccessories = accessories;
    // 1. Combine and map
    const providedSet = new Set(this.accessoriesConfig.accessoriesProvided.map(x => x.value));
    const missingSet = new Set(this.accessoriesConfig.accessoriesMissing.map(x => x.value));

    const allKeys = new Set([
      ...Object.keys(jobDetailAccessories),
      ...this.accessoriesConfig.accessoriesProvided.map(x => x.value),
      ...this.accessoriesConfig.accessoriesMissing.map(x => x.value)
    ]);

    const providedArray: any[] = [];
    const missingArray: any[] = [];
    const miscArray: any[] = [];

    allKeys.forEach(key => {
      // Skip static fields
      if (['Comment', 'color', 'remarks', 'PatternLock'].includes(key)) return;

      let label = key;
      let group = 'misc';

      const providedItem = this.accessoriesConfig.accessoriesProvided.find(x => x.value === key);
      const missingItem = this.accessoriesConfig.accessoriesMissing.find(x => x.value === key);

      if (providedItem) {
        label = providedItem.label;
        group = 'provided';
      } else if (missingItem) {
        label = missingItem.label;
        group = 'missing';
      }

      const value = jobDetailAccessories[key] ?? false;

      const obj = { label, value: key, checked: value };

      if (group === 'provided') providedArray.push(obj);
      else if (group === 'missing') missingArray.push(obj);
      else miscArray.push(obj);
    });

    // 2. Build FormGroup
    const group: any = {};
    [...providedArray, ...missingArray, ...miscArray].forEach(item => {
      group[item.value] = [item.checked];
    });
    group['Comment'] = [jobDetailAccessories.Comment ?? ''];
    group['color'] = [jobDetailAccessories.color ?? ''];
    group['remarks'] = [jobDetailAccessories.remarks ?? ''];

    (this.serviceNearDetailForm.get('jobDetailFormGroup') as FormGroup).addControl(
      'accessories',
      this.fb.group(group)
    );

    // 3. Use providedArray and missingArray for UI
    this.providedArray = [...providedArray, ...miscArray];
    this.missingArray = missingArray;

    (this.serviceNearDetailForm.get('jobDetailFormGroup') as FormGroup)
              .get('accessories')
              ?.patchValue(jobDetailAccessories);
  }

  public GetThirdPartySettings(){
    this.configService.getSellerSettingsBySellerId({filters: "ThirdPartySettings"}).subscribe((res: any) => {
      if (res && res?.ResponseData && res?.ResponseData?.ThirdPartySettings) {
        const data = JSON.parse(res.ResponseData.ThirdPartySettings);
        const accessoriesConfig = JSON.parse(data.servicenear.accessoriesConfig);
        if(accessoriesConfig){
          this.accessoriesConfig.accessoriesProvided = accessoriesConfig.accessoriesProvided || [];
          this.accessoriesConfig.accessoriesMissing = accessoriesConfig.accessoriesMissing || [];
          
        }else{
          this.accessoriesConfig.accessoriesProvided = [];
          this.accessoriesConfig.accessoriesMissing = [];
        }

      }else{
        this.accessoriesConfig.accessoriesProvided = [];
        this.accessoriesConfig.accessoriesMissing = [];
      }

    });

  }

  public startPatternAnimation(pattern: number[]) {
    if (this.patternInterval) { 
        clearInterval(this.patternInterval);
    }
    const control = this.serviceNearDetailForm
      .get('jobDetailFormGroup')
      ?.get('PatternLock');

    let index = 1;

    this.patternInterval = setInterval(() => {
      control?.setValue(pattern.slice(0, index));

      index++;

      if (index > pattern.length) {
        index = 1;
      }
    }, 500);
  }

  public toggleJobDetailsEditMode() {
    this.isEditMode = !this.isEditMode;

    if (!this.isEditMode) {
      if (this.jobDetails[0]?.Pattern) {
        const devicePass = JSON.parse(this.jobDetails[0]?.Pattern);

        if (devicePass.pat) {
          this.startPatternAnimation(devicePass.pat);
          this.serviceNearDetailForm.get('jobDetailFormGroup')?.get('Pattern')?.setValue('');
        } 
      }
      this.updateColor('#d3d3d3');
    } else {
      if (this.patternInterval) {
        clearInterval(this.patternInterval);
      }

      if (this.jobDetails[0]?.Pattern) {
        const devicePass = JSON.parse(this.jobDetails[0]?.Pattern);

        if (devicePass.pat) {
          this.serviceNearDetailForm.get('jobDetailFormGroup')?.get('Pattern')?.setValue('');
          this.serviceNearDetailForm.get('jobDetailFormGroup')?.get('PatternLock')?.setValue(devicePass.pat);
        } 
      }
      this.updateColor('#3b82f6');
    }
  }

  public changePatternOrPassword(pass: number) {
    this.pass = pass;
  }

  public updateColor(color: string) {
    if (this.patternLock?.nativeElement) { 
      setTimeout(() => {
        this.patternLock.nativeElement.style.setProperty('--pattern-color', color);
      }, 500);
    }
  }

  public resetPattern(){
    const control = this.serviceNearDetailForm
      .get('jobDetailFormGroup')
      ?.get('PatternLock');

    setTimeout(() => {
        control?.setValue([]);
      }, 500);
  }

  public revertPattern(){
    const control = this.serviceNearDetailForm
      .get('jobDetailFormGroup')
      ?.get('PatternLock');

    setTimeout(() => {
      if (this.jobDetails[0]?.Pattern) {
        const devicePass = JSON.parse(this.jobDetails[0]?.Pattern);
        if(devicePass.pat){
          control?.setValue(devicePass.pat);
        }
      }
      }, 500);
  }
}
